var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankingImg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2320 1328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#bdd0fb;}.cls-4{fill:#91b3fa;}.cls-5{fill:#7d97f4;}.cls-6{fill:#18174a;}.cls-7{fill:#2b69b3;}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15,.cls-16,.cls-21,.cls-57,.cls-72{fill:#fff;}.cls-15{opacity:0.85;}.cls-16{opacity:0.69;}.cls-17{fill:url(#linear-gradient-9);}.cls-18{clip-path:url(#clip-path);}.cls-19{fill:url(#linear-gradient-10);}.cls-20{fill:url(#linear-gradient-11);}.cls-21{opacity:0.72;}.cls-22{fill:url(#linear-gradient-12);}.cls-23{fill:url(#linear-gradient-13);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:url(#linear-gradient-15);}.cls-26{fill:url(#linear-gradient-16);}.cls-27{fill:url(#linear-gradient-17);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#linear-gradient-20);}.cls-31{fill:url(#linear-gradient-21);}.cls-32{fill:url(#linear-gradient-22);}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#linear-gradient-24);}.cls-35{fill:url(#linear-gradient-25);}.cls-36{fill:url(#linear-gradient-26);}.cls-37{fill:url(#linear-gradient-27);}.cls-38{fill:url(#linear-gradient-28);}.cls-39{fill:url(#linear-gradient-29);}.cls-40{fill:url(#linear-gradient-30);}.cls-41{fill:url(#linear-gradient-31);}.cls-42{fill:url(#linear-gradient-32);}.cls-43{fill:url(#linear-gradient-33);}.cls-44{fill:url(#linear-gradient-34);}.cls-45{fill:url(#linear-gradient-35);}.cls-46{fill:url(#linear-gradient-36);}.cls-47{fill:url(#linear-gradient-37);}.cls-48{fill:url(#linear-gradient-38);}.cls-49{fill:url(#linear-gradient-39);}.cls-50{fill:url(#linear-gradient-40);}.cls-51{fill:url(#linear-gradient-41);}.cls-52{fill:url(#linear-gradient-42);}.cls-53{fill:url(#linear-gradient-43);}.cls-54{fill:url(#linear-gradient-44);}.cls-55{fill:url(#linear-gradient-45);}.cls-56{fill:url(#linear-gradient-46);}.cls-57{opacity:0.78;}.cls-58{fill:url(#linear-gradient-47);}.cls-59{fill:url(#linear-gradient-48);}.cls-60{fill:url(#linear-gradient-49);}.cls-61{fill:url(#linear-gradient-50);}.cls-62{fill:url(#linear-gradient-51);}.cls-63{fill:url(#linear-gradient-52);}.cls-64{fill:url(#linear-gradient-53);}.cls-65{fill:url(#linear-gradient-54);}.cls-66{fill:url(#linear-gradient-55);}.cls-67{fill:url(#linear-gradient-56);}.cls-68{fill:url(#linear-gradient-57);}.cls-69{fill:url(#linear-gradient-58);}.cls-70{fill:url(#linear-gradient-59);}.cls-71{fill:url(#linear-gradient-60);}.cls-73{fill:url(#linear-gradient-61);}.cls-74{fill:url(#linear-gradient-62);}.cls-75{fill:url(#linear-gradient-63);}.cls-76{fill:url(#linear-gradient-64);}.cls-77{fill:url(#linear-gradient-65);}.cls-78{fill:url(#linear-gradient-66);}.cls-79{fill:url(#linear-gradient-67);}.cls-80{fill:url(#linear-gradient-68);}.cls-81{fill:url(#linear-gradient-69);}.cls-82{fill:url(#linear-gradient-70);}.cls-83{fill:url(#linear-gradient-71);}.cls-84{fill:url(#linear-gradient-72);}.cls-85{fill:url(#linear-gradient-73);}.cls-86{fill:url(#linear-gradient-74);}.cls-87{fill:url(#linear-gradient-75);}.cls-88{fill:url(#linear-gradient-76);}.cls-89{fill:url(#linear-gradient-77);}.cls-90{fill:url(#linear-gradient-78);}.cls-91{fill:url(#linear-gradient-79);}.cls-92{fill:url(#linear-gradient-80);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.97,
    y1: 612.85,
    x2: 2229.4,
    y2: 612.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1105.5,
    y1: 1035.25,
    x2: 1043.48,
    y2: 1261.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1103.25,
    y1: 1035.11,
    x2: 1041.29,
    y2: 1260.82,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1097.48,
    y1: 1033.97,
    x2: 1035.52,
    y2: 1259.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1095.97,
    y1: 1033.92,
    x2: 1034.05,
    y2: 1259.48,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1107.51,
    y1: 984.69,
    x2: 1116.22,
    y2: 486.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1148.81,
    y1: 787.44,
    x2: 1162.39,
    y2: 1218.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1071.55,
    y1: 789.78,
    x2: 1085.13,
    y2: 1221.2,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1013.19,
    y1: 564.21,
    x2: 1219.77,
    y2: 564.21,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1026.24 575.08 1208.9 575.08 1276.31 575.08 1319.8 444.87 1319.8 336.69 1045.81 237.73 887.34 412.75 1026.24 575.08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 909.92,
    y1: 500.96,
    x2: 969.11,
    y2: 432.26,
    gradientTransform: "translate(1166.72 -612.46) rotate(76.72)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1002.55,
    y1: 382.16,
    x2: 827.53,
    y2: 646.56,
    gradientTransform: "translate(588.87 -559.91) rotate(45)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 997.33,
    y1: 389.73,
    x2: 904.14,
    y2: 546.19,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1011.15,
    y1: 341.51,
    x2: 1164.78,
    y2: 341.51,
    gradientTransform: "translate(1217.57 -791.4) rotate(79.1)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1144.11,
    y1: 256.7,
    x2: 839.43,
    y2: 716.98,
    gradientTransform: "translate(1235.53 -789.21) rotate(80.01)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1135.02,
    y1: 269.89,
    x2: 972.78,
    y2: 542.25,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1032.78,
    y1: 638.63,
    x2: 1138.8,
    y2: 515.57,
    gradientTransform: "translate(1351.43 -720.08) rotate(75.47)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1173.35,
    y1: 404.83,
    x2: 1142.02,
    y2: 509.49,
    gradientTransform: "translate(696.98 -656.49) rotate(45)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1166.27,
    y1: 418.86,
    x2: 1128.27,
    y2: 579.53,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1163.09,
    y1: 497.4,
    x2: 1240.78,
    y2: 407.23,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1284.67,
    y1: 341.47,
    x2: 1054.96,
    y2: 688.49,
    gradientTransform: "translate(650.54 -759.73) rotate(45)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1277.82,
    y1: 351.41,
    x2: 1155.5,
    y2: 556.76,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -2328.17,
    y1: 467.35,
    x2: -2243.73,
    y2: 659.47,
    gradientTransform: "translate(3673.3 -303.38) rotate(-12.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1916.37,
    y1: 1290.47,
    x2: -1877.61,
    y2: 1290.47,
    gradientTransform: "translate(3686.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -2080.14,
    y1: 1443.31,
    x2: -2024.36,
    y2: 791.44,
    gradientTransform: "translate(3686.63)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -1967.94,
    y1: 1453.01,
    x2: -1912.15,
    y2: 800.97,
    gradientTransform: "translate(3686.63)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1545.92,
    y1: 800.47,
    x2: 1665.9,
    y2: 800.47,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -2086.25,
    y1: 800.76,
    x2: -2075.78,
    y2: 724.11,
    gradientTransform: "translate(3686.63)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -2246.53,
    y1: 555.06,
    x2: -2155.11,
    y2: 392.37,
    gradientTransform: "translate(3677.49 -272.51) rotate(-11.2)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2227.07,
    y1: 566,
    x2: -2135.65,
    y2: 403.3,
    gradientTransform: "translate(3677.49 -272.51) rotate(-11.2)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -2344.86,
    y1: 474.69,
    x2: -2260.42,
    y2: 666.81,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -471.71,
    y1: 592.54,
    x2: -449.15,
    y2: 592.54,
    gradientTransform: "matrix(-1, 0, 0, 1, 975.19, 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -845.01,
    y1: 859.99,
    x2: -658.94,
    y2: 859.99,
    gradientTransform: "matrix(-1, 0, 0, 1, 975.19, 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 2035.31,
    y1: 1615.34,
    x2: 2064.36,
    y2: 1615.34,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, -1745.21, 92.97)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 2073.84,
    y1: 1650.5,
    x2: 1972.74,
    y2: 1782.71,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, -1745.21, 92.97)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 2023.24,
    y1: 1679.14,
    x2: 2101.36,
    y2: 1679.14,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, -1745.21, 92.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 2014.3,
    y1: 1642.15,
    x2: 2041.57,
    y2: 1642.15,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, -1745.21, 92.97)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 507.71,
    y1: 927.05,
    x2: 618.51,
    y2: 927.05,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 2112.42,
    y1: 1355.18,
    x2: 2207.53,
    y2: 1355.18,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, -1745.21, 92.97)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 374.5,
    y1: 928.98,
    x2: 561.93,
    y2: 928.98,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 520.49,
    y1: 728.37,
    x2: 470.99,
    y2: 924.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 304.02,
    y1: 906.75,
    x2: 415.14,
    y2: 906.75,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 482.19,
    y1: 898.7,
    x2: 399.69,
    y2: 1002.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1461.31,
    y1: 404.79,
    x2: 1382.43,
    y2: 509.15,
    gradientTransform: "matrix(0.65, -0.76, 0.76, 0.65, -756.57, 1576.61)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1345.77,
    y1: 487.43,
    x2: 1409.05,
    y2: 422.52,
    gradientTransform: "matrix(0.65, -0.76, 0.76, 0.65, -756.57, 1576.61)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 620.6,
    y1: 361.68,
    x2: 758.63,
    y2: 201.47,
    gradientTransform: "translate(363.19 -480.34) rotate(45)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 836.62,
    y1: 84.62,
    x2: 428.47,
    y2: 701.22,
    gradientTransform: "translate(363.19 -480.34) rotate(45)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 780.19,
    y1: 146.32,
    x2: 581.22,
    y2: 424.01,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 809.03,
    y1: 166.99,
    x2: 610.06,
    y2: 444.68,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 473.27,
    y1: 392.91,
    x2: 561.33,
    y2: 290.69,
    gradientTransform: "translate(81.38 -121.66) rotate(13.28)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 611.09,
    y1: 216.15,
    x2: 350.7,
    y2: 609.52,
    gradientTransform: "translate(369.02 -313.64) rotate(45)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 575.09,
    y1: 255.51,
    x2: 448.15,
    y2: 432.67,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 593.49,
    y1: 268.7,
    x2: 466.55,
    y2: 445.85,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 500.96,
    y1: 598.28,
    x2: 589.02,
    y2: 496.07,
    gradientTransform: "translate(821.11 -240.87) rotate(67.5)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 638.78,
    y1: 421.52,
    x2: 378.39,
    y2: 814.9,
    gradientTransform: "translate(522.36 -273.07) rotate(45)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 602.78,
    y1: 460.89,
    x2: 475.84,
    y2: 638.05,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 621.18,
    y1: 474.07,
    x2: 494.24,
    y2: 651.23,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 921.67,
    y1: 255.69,
    x2: 977.49,
    y2: 190.89,
    gradientTransform: "translate(147.04 -360.07) rotate(22.5)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1009.03,
    y1: 143.63,
    x2: 843.96,
    y2: 393.01,
    gradientTransform: "translate(420.69 -636.46) rotate(45)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 986.21,
    y1: 168.59,
    x2: 905.74,
    y2: 280.9,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 997.88,
    y1: 176.95,
    x2: 917.4,
    y2: 289.26,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -1522.28,
    y1: 361.68,
    x2: -1384.25,
    y2: 201.47,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 682.86, -918.78)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -1306.26,
    y1: 84.62,
    x2: -1714.41,
    y2: 701.22,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 682.86, -918.78)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -1362.69,
    y1: 146.32,
    x2: -1561.66,
    y2: 424.01,
    gradientTransform: "matrix(-1, 0, 0, 1, 138.07, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -1333.85,
    y1: 166.99,
    x2: -1532.82,
    y2: 444.68,
    gradientTransform: "matrix(-1, 0, 0, 1, 138.07, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -1669.6,
    y1: 392.91,
    x2: -1581.55,
    y2: 290.69,
    gradientTransform: "matrix(-0.24, -0.97, -0.97, 0.24, 1624.86, -1314.59)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -1531.79,
    y1: 216.15,
    x2: -1792.18,
    y2: 609.52,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 804.86, -1032.53)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -1567.79,
    y1: 255.51,
    x2: -1694.73,
    y2: 432.67,
    gradientTransform: "matrix(-1, 0, 0, 1, 138.07, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -1549.39,
    y1: 268.7,
    x2: -1676.33,
    y2: 445.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 138.07, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -1641.91,
    y1: 598.28,
    x2: -1553.86,
    y2: 496.07,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 941.98, -952.79)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -1504.1,
    y1: 421.52,
    x2: -1764.49,
    y2: 814.9,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 941.98, -952.79)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -1540.1,
    y1: 460.89,
    x2: -1667.04,
    y2: 638.05,
    gradientTransform: "matrix(-1, 0, 0, 1, 138.07, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -1521.7,
    y1: 474.07,
    x2: -1648.64,
    y2: 651.23,
    gradientTransform: "matrix(-1, 0, 0, 1, 138.07, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -1221.21,
    y1: 255.69,
    x2: -1165.39,
    y2: 190.89,
    gradientTransform: "matrix(-0.38, -0.92, -0.92, 0.38, 1031.94, -958.6)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -1133.84,
    y1: 143.63,
    x2: -1298.92,
    y2: 393.01,
    gradientTransform: "matrix(-0.81, -0.58, -0.58, 0.81, 468.69, -644.97)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -1156.67,
    y1: 168.59,
    x2: -1237.14,
    y2: 280.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 138.07, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -1145,
    y1: 176.95,
    x2: -1225.47,
    y2: 289.26,
    gradientTransform: "matrix(-1, 0, 0, 1, 138.07, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -1100.76,
    y1: 260.68,
    x2: -1012.7,
    y2: 158.47,
    gradientTransform: "matrix(-0.95, -0.32, -0.32, 0.95, 239.4, -311.66)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -962.94,
    y1: 83.92,
    x2: -1223.33,
    y2: 477.29,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 544.75, -669.02)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -998.95,
    y1: 123.28,
    x2: -1125.89,
    y2: 300.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 138.07, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -980.54,
    y1: 136.47,
    x2: -1107.48,
    y2: 313.63,
    gradientTransform: "matrix(-1, 0, 0, 1, 138.07, 0)",
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2166.24,675.2c-38.71-35.26-84.48-69.65-96.41-117.52-20.66-82.84,67.66-153.48,96.57-234.39,20-55.94,9.68-119.64-27.28-168.45s-99.79-81.76-166.19-87.11c-114.24-9.22-226,58.48-338.59,38.88-90.11-15.7-161.32-85-252.79-92.38-107.64-8.74-197,69.41-299.73,98.84-122.95,35.19-256.25-1.59-377.12-41.95S456.64-14.27,329.23,5C187.4,26.55,68.48,135.24,49.52,260.71,30.72,385.06,188.38,484.88,54.17,634.2,12.23,680.85-15.67,745.82,2.87,803c18,55.58,94.68,90.73,95.24,148.52.44,45.62-48.47,81.92-52.41,127.41-3.38,39,28.55,75.15,67.79,93.65s84.77,23,129,27.23l-13,12.34c223,17.6,447.34,13.68,671.17,9.75l1058.95-18.61c36.27-.64,73.43-1.42,107.23-13s64.12-36.43,69.27-68c8.76-53.76-55.13-100.42-49.23-154.48,7.54-69,118.07-95.67,139.1-162.51C2240.83,758,2204.94,710.46,2166.24,675.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1498.06,1170.58c-116.78-65.95-175.78-238-127-302.56,42.35-56,151-11.38,177.31-63.42,31.67-62.5-108.8-158.82-79-232C1498,502.5,1647.85,540.5,1678,471.11,1710.12,397,1556.38,314,1577.24,208.48c17.4-88,150.47-162.43,271.68-139.15,98.64,19,198.19,104.32,192.38,181.33-7.93,105.12-206.7,122.1-212,224.66-4.83,94.63,161.32,140.75,150.19,224.79-12,90.46-213.49,105-214.43,177.74-.82,63.88,154.38,80.84,158.84,144.95C1929.84,1107.58,1671.72,1268.65,1498.06,1170.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1804.4,198.52c-10.57,77.29-23.34,154.18-37.05,230.9-6.74,38.38-14.14,76.62-21.4,114.91-3.69,19.12-7.64,38.2-11.46,57.3s-7.62,38.2-11.76,57.24L1710.46,716c-4.23,19-8.37,38-12.75,57l-3.25,14.24-3.37,14.22-6.74,28.43-6.8,28.41-7.2,28.32c-19.17,75.48-39.6,150.84-66.45,224l-1.45-.5c20.94-74.93,38.14-150.77,55.09-226.67l6.34-28.47,6.17-28.51,6.22-28.5,3.11-14.25,3-14.27c3.93-19.06,8.1-38.05,12.18-57.07l11.91-57.12,47.63-228.57c15.85-76.21,31.9-152.4,48.81-228.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M479.25,745.14a104.31,104.31,0,0,1-30.09-99.93c9.1-38.8,9.74-83.62,0-129.73C423.55,394.5,336,310.55,253.63,328S125.21,457.62,150.81,578.61a321.28,321.28,0,0,0,21.42,65.8,102.65,102.65,0,0,1-5.06,95,131.57,131.57,0,0,0,68,191.05A103.24,103.24,0,0,1,291.65,980c33.83,65.5,94.25,104.54,152.84,92.15,75.08-15.89,118.71-110.25,97.45-210.76C531.8,813.51,508.74,772.85,479.25,745.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M492.73,1212.62a5.11,5.11,0,0,1-4.94-2.41c-52.69-86.66-96-239.76-123-353-29.22-122.42-46.28-225.82-46.45-226.85a5.09,5.09,0,1,1,10-1.64c.67,4.1,68.42,412.25,168.09,576.15a5.09,5.09,0,0,1-3.75,7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M474.53,142.63l-44.8,81.74a80.67,80.67,0,0,0-3.52,70.29l57.92,136.45a80.74,80.74,0,0,1,4.49,49l-15.9,71.52a80.68,80.68,0,0,0,21.48,74.3h0a80.66,80.66,0,0,0,112.28,2.19L657,581a80.66,80.66,0,0,0,20.75-86.65L641.12,394a80.75,80.75,0,0,1-3.93-40.11l21.71-139a80.65,80.65,0,0,0-37.26-81l-33.94-21A80.66,80.66,0,0,0,474.53,142.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M553.17,668.3a3.89,3.89,0,0,1-.68,0,4.12,4.12,0,0,1-3.39-4.74c34.63-208.5-10.35-435.12-14.9-446.69a4.12,4.12,0,0,1,6-5.49c1.13.91,1.88,1.51,4.58,13.75,1.24,5.64,3.25,15.48,5.78,30.34,3.81,22.33,9.24,58.65,13.49,105,7.11,77.37,11.69,193-6.83,304.49A4.12,4.12,0,0,1,553.17,668.3ZM535.05,217.76h0Zm0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1993.52,1070.07c33.38-52.48,46.29-110.74,40-161.67-5.64-45.52,6.21-91.65,33.85-128.21q4.37-5.76,8.34-12c40.15-63.12,34-138.89-13.69-169.23s-118.93-3.77-159.07,59.35a175.41,175.41,0,0,0-18.86,39.81c-14,43-43.11,79.63-82.76,101.33-35.44,19.4-68.28,49.7-93.31,89-37.32,58.68-49,124.59-36.94,179.39a173.89,173.89,0,0,1,2.26,63.17c-5.22,34.86,6.37,68.11,33.16,85.14,28.89,18.38,67.37,12.74,98-11a185.32,185.32,0,0,1,58-29.87C1911.8,1159.74,1959.77,1123.13,1993.52,1070.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2036,676.72c-20.3,45.68-42,90.67-64.27,135.43-5.55,11.2-11.28,22.3-17,33.42l-8.55,16.68-8.68,16.61c-5.83,11-11.51,22.18-17.46,33.17l-17.87,33c-12.19,21.81-24.2,43.73-36.79,65.32-6.29,10.81-12.36,21.73-18.86,32.41l-19.35,32.11c-26.24,42.55-53.56,84.46-83,124.9l-1.75-1.25,20.83-31.1,5.23-7.76,5-7.89,10-15.8,10.06-15.78c3.36-5.25,6.53-10.63,9.8-15.94,6.48-10.66,13-21.27,19.45-32q38-64.49,74-130.13c11.78-22,23.74-43.91,35.36-66l8.76-16.54,8.63-16.61c5.75-11.08,11.51-22.15,17.15-33.28q17.22-33.25,33.94-66.76,16.88-33.42,33.27-67.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.45,295a2.18,2.18,0,0,1-2.14-1.8c-.5-2.87-1-5.8-1.31-8.71a2.17,2.17,0,0,1,4.31-.54c.36,2.84.79,5.7,1.28,8.5a2.17,2.17,0,0,1-1.76,2.51A2.58,2.58,0,0,1,103.45,295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.84,259.29h-.06a2.18,2.18,0,0,1-2.11-2.24c.16-5.6.58-11.27,1.27-16.86a2.17,2.17,0,1,1,4.31.53c-.66,5.45-1.08,11-1.23,16.45A2.19,2.19,0,0,1,100.84,259.29ZM107.39,216a1.93,1.93,0,0,1-.58-.08,2.18,2.18,0,0,1-1.52-2.68c1.51-5.41,3.29-10.81,5.3-16a2.17,2.17,0,1,1,4.06,1.55c-2,5.12-3.7,10.39-5.17,15.67A2.17,2.17,0,0,1,107.39,216Zm16.83-40.39a2.1,2.1,0,0,1-1.07-.29,2.18,2.18,0,0,1-.82-3c2.78-4.86,5.84-9.67,9.07-14.27a2.18,2.18,0,0,1,3.56,2.5c-3.16,4.49-6.14,9.18-8.85,13.93A2.17,2.17,0,0,1,124.22,175.63Zm26.22-35a2.14,2.14,0,0,1-1.51-.61,2.17,2.17,0,0,1-.06-3.07c3.89-4,8-8,12.27-11.64a2.18,2.18,0,0,1,2.84,3.3c-4.14,3.58-8.17,7.39-12,11.35A2.16,2.16,0,0,1,150.44,140.59ZM184.38,113a2.17,2.17,0,0,1-1.16-4c4.76-3,9.71-5.79,14.72-8.31a2.17,2.17,0,0,1,2,3.88c-4.89,2.47-9.72,5.2-14.36,8.11A2.13,2.13,0,0,1,184.38,113Zm183-4a2.11,2.11,0,0,1-1.08-.29c-4.77-2.71-9.72-5.22-14.71-7.46a2.18,2.18,0,1,1,1.78-4c5.12,2.3,10.19,4.88,15.08,7.65a2.18,2.18,0,0,1-1.07,4.07ZM224,94.41a2.17,2.17,0,0,1-.67-4.24c5.34-1.74,10.82-3.25,16.3-4.48a2.17,2.17,0,1,1,.95,4.24c-5.34,1.2-10.69,2.67-15.9,4.37A2,2,0,0,1,224,94.41Zm102.93-2.24a2.3,2.3,0,0,1-.58-.07c-5.09-1.41-10.31-2.6-15.51-3.55l-.59-.11a2.18,2.18,0,0,1,.78-4.28l.59.11c5.33,1,10.67,2.19,15.89,3.63a2.17,2.17,0,0,1-.58,4.27Zm-60-6.1a2.18,2.18,0,0,1-.14-4.35c5.6-.38,11.25-.5,16.9-.35a2.18,2.18,0,0,1,2.12,2.23,2.21,2.21,0,0,1-2.23,2.12c-5.51-.15-11,0-16.5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M396.6,129.72a2.15,2.15,0,0,1-1.43-.53c-2.15-1.89-4.37-3.74-6.6-5.5a2.18,2.18,0,1,1,2.71-3.41c2.28,1.81,4.55,3.7,6.75,5.63a2.17,2.17,0,0,1-1.43,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.49,256.82a2.18,2.18,0,0,1-2.17-2.09c-.11-2.85-.3-5.73-.55-8.57a2.17,2.17,0,1,1,4.33-.38c.26,2.9.45,5.86.56,8.78a2.17,2.17,0,0,1-2.08,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M279.41,442.51h-1.67a2.18,2.18,0,0,1,0-4.35h1.65c5.48,0,11-.27,16.47-.78a2.14,2.14,0,0,1,2.37,2,2.17,2.17,0,0,1-2,2.37C290.7,442.25,285,442.51,279.41,442.51Zm-31.3-2.76-.39,0-.92-.17c-5.77-1.05-11.54-2.39-17.16-4a2.17,2.17,0,1,1,1.18-4.18c5.49,1.55,11.13,2.87,16.76,3.89l.91.17a2.17,2.17,0,0,1-.38,4.31Zm77.27-3.31a2.17,2.17,0,0,1-.56-4.27A176.39,176.39,0,0,0,342,426.58a2.17,2.17,0,0,1,1.56,4.06A183.4,183.4,0,0,1,326,436.37,2.22,2.22,0,0,1,325.38,436.44Zm-123-11.3a2.08,2.08,0,0,1-.93-.22,178.57,178.57,0,0,1-16.33-8.84,2.17,2.17,0,0,1,2.26-3.71A177.63,177.63,0,0,0,203.3,421a2.18,2.18,0,0,1-.94,4.14Zm167.29-7.28a2.18,2.18,0,0,1-1.1-4.05,179.39,179.39,0,0,0,15.12-10,2.18,2.18,0,0,1,2.58,3.51c-5,3.65-10.19,7.09-15.5,10.22A2.17,2.17,0,0,1,369.65,417.86Zm37.75-29.68a2.19,2.19,0,0,1-1.52-.62,2.17,2.17,0,0,1,0-3.07,175.49,175.49,0,0,0,11.92-13.64,2.18,2.18,0,0,1,3.42,2.69,182.45,182.45,0,0,1-12.22,14A2.18,2.18,0,0,1,407.4,388.18Zm28.47-38.67A2.17,2.17,0,0,1,434,346.3,176.23,176.23,0,0,0,441.8,330a2.17,2.17,0,1,1,4,1.67,178.7,178.7,0,0,1-8,16.75A2.17,2.17,0,0,1,435.87,349.51Zm17.07-44.88a2.2,2.2,0,0,1-.5-.06,2.17,2.17,0,0,1-1.62-2.61c.65-2.78,1.23-5.62,1.75-8.42.56-3.12,1.05-6.29,1.46-9.41a2.17,2.17,0,0,1,4.31.55c-.41,3.2-.91,6.44-1.5,9.64-.52,2.87-1.12,5.78-1.78,8.62A2.18,2.18,0,0,1,452.94,304.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.12,398.72a2.17,2.17,0,0,1-1.43-.53c-2.18-1.9-4.36-3.9-6.49-5.94a2.18,2.18,0,0,1,3-3.14c2.07,2,4.2,3.95,6.33,5.8a2.17,2.17,0,0,1-1.43,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.63,348.08a2.17,2.17,0,0,0,2.31.92l25.31-6.22a113.33,113.33,0,0,0,30.24,20.92l3.11,25.86a2.14,2.14,0,0,0,1.68,1.84L265.83,398a2.16,2.16,0,0,0,2.29-1l13.48-22.28a113.21,113.21,0,0,0,36.18-6.61l20.5,16.1a2.14,2.14,0,0,0,2.48.11L367,367.37a2.13,2.13,0,0,0,.92-2.31l-6.22-25.3a113.8,113.8,0,0,0,20.93-30.25l25.85-3.11a2.14,2.14,0,0,0,1.84-1.67l6.59-30.56a2.13,2.13,0,0,0-1-2.28L393.68,258.4a113.55,113.55,0,0,0-6.62-36.18l16.1-20.5a2.13,2.13,0,0,0,.11-2.48L386.33,173a2.16,2.16,0,0,0-2.32-.91l-25.3,6.22a113.34,113.34,0,0,0-30.25-20.93l-3.11-25.86a2.14,2.14,0,0,0-1.67-1.84l-30.56-6.59a2.15,2.15,0,0,0-2.28,1l-13.49,22.28a113.26,113.26,0,0,0-36.18,6.61l-20.5-16.1a2.13,2.13,0,0,0-2.48-.11l-26.26,17A2.13,2.13,0,0,0,191,156l6.22,25.31a113.36,113.36,0,0,0-20.93,30.24l-25.86,3.11a2.15,2.15,0,0,0-1.84,1.67L142,246.88a2.13,2.13,0,0,0,1,2.28l22.28,13.49a113.54,113.54,0,0,0,6.61,36.18l-16.09,20.5a2.14,2.14,0,0,0-.12,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279.45,291.54a31.1,31.1,0,1,1,1.11,0C280.19,291.54,279.82,291.54,279.45,291.54ZM279.5,236l-.88,0A24.49,24.49,0,1,0,280.33,285h0a24.49,24.49,0,0,0-.83-49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280,338.82a78.71,78.71,0,0,1-16.6-1.78h0a79.49,79.49,0,0,1-15.91-5.23l2.69-5.95a73.47,73.47,0,0,0,14.6,4.81l1,.21A72.24,72.24,0,0,0,350.4,276l.15-.69a72.17,72.17,0,1,0-138.9,8l-6.18,2.1A78.7,78.7,0,1,1,280,338.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M427.33,194.48l13.86-4.6A63.64,63.64,0,0,0,459,200.23l2.89,14.3a1.19,1.19,0,0,0,1,.95l17.36,2.33a1.22,1.22,0,0,0,1.23-.65l6.55-13a63.47,63.47,0,0,0,19.91-5.3l12.16,8.08a1.2,1.2,0,0,0,1.4,0l13.91-10.64a1.18,1.18,0,0,0,.41-1.33L531.25,181a63.47,63.47,0,0,0,10.34-17.82l14.31-2.88a1.2,1.2,0,0,0,1-1l2.32-17.36a1.19,1.19,0,0,0-.65-1.23l-13-6.54a63.73,63.73,0,0,0-5.3-19.92l8.08-12.16a1.2,1.2,0,0,0,0-1.39L537.58,86.78a1.2,1.2,0,0,0-1.33-.41L522.39,91a63.64,63.64,0,0,0-17.82-10.35l-2.89-14.3a1.19,1.19,0,0,0-1-.95L483.31,63a1.23,1.23,0,0,0-1.24.65l-6.54,13A63.47,63.47,0,0,0,455.62,82L443.45,74a1.19,1.19,0,0,0-1.39,0L428.14,84.64a1.21,1.21,0,0,0-.41,1.33l4.6,13.86A63.47,63.47,0,0,0,422,117.65l-14.31,2.88a1.2,1.2,0,0,0-.95,1l-2.32,17.36a1.19,1.19,0,0,0,.65,1.23l13,6.54a63.46,63.46,0,0,0,5.3,19.92l-8.08,12.16a1.2,1.2,0,0,0,.05,1.39L426,194.07A1.2,1.2,0,0,0,427.33,194.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M481.75,159.24a18.82,18.82,0,0,1-2.11-37.51,18.82,18.82,0,0,1,4.29,37.39A20,20,0,0,1,481.75,159.24Zm.05-31.11a11.12,11.12,0,0,0-1.41.09,12.29,12.29,0,1,0,2.8,24.41h0A12.29,12.29,0,0,0,494,139,12.31,12.31,0,0,0,481.8,128.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M398,185a2.18,2.18,0,0,1-1.95-1.19c-1.33-2.64-2.56-5.37-3.64-8.12a2.18,2.18,0,1,1,4.05-1.59c1,2.62,2.2,5.23,3.47,7.75A2.16,2.16,0,0,1,398,185Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M388.14,149.24a2.19,2.19,0,0,1-2.17-2c-.16-2.3-.24-4.63-.24-6.93a95.21,95.21,0,0,1,.64-11.08,2.17,2.17,0,0,1,4.32.5,91,91,0,0,0-.61,10.58c0,2.2.08,4.43.23,6.62a2.16,2.16,0,0,1-2,2.32Zm8-45.11a2.17,2.17,0,0,1-2-3.07A97.25,97.25,0,0,1,403,85.4a2.18,2.18,0,1,1,3.57,2.49,92.49,92.49,0,0,0-8.5,15A2.17,2.17,0,0,1,396.13,104.13Zm28.39-36a2.17,2.17,0,0,1-1.33-3.89,96.3,96.3,0,0,1,15.24-9.62,2.18,2.18,0,0,1,2,3.89,91.22,91.22,0,0,0-14.54,9.17A2.14,2.14,0,0,1,424.52,68.17Zm42-18.23a2.17,2.17,0,0,1-.35-4.32c1.54-.25,3.09-.47,4.65-.65a97.44,97.44,0,0,1,13.32-.61,2.17,2.17,0,0,1,2.12,2.23,2.2,2.2,0,0,1-2.22,2.12,93.39,93.39,0,0,0-12.72.58c-1.5.17-3,.38-4.45.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M520.38,57a2.24,2.24,0,0,1-.9-.19c-2.57-1.17-5.23-2.22-7.89-3.13A2.18,2.18,0,1,1,513,49.53c2.78,1,5.57,2.07,8.27,3.29a2.17,2.17,0,0,1-.9,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M571.74,115.59a2.17,2.17,0,0,1-2.08-1.55c-.81-2.7-1.75-5.4-2.81-8a2.17,2.17,0,1,1,4-1.62c1.11,2.74,2.1,5.56,2.94,8.39a2.17,2.17,0,0,1-2.08,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.68,236.48c-2.38,0-4.8-.09-7.19-.27a2.17,2.17,0,0,1-2-2.33,2.15,2.15,0,0,1,2.33-2,92.78,92.78,0,0,0,16.91-.3,2.18,2.18,0,1,1,.47,4.33A97.58,97.58,0,0,1,481.68,236.48Zm37.42-7.71a2.17,2.17,0,0,1-.86-4.17,91.62,91.62,0,0,0,14.83-8.12,2.18,2.18,0,0,1,2.43,3.61,95.58,95.58,0,0,1-15.54,8.5A2.18,2.18,0,0,1,519.1,228.77Zm35.83-27.31a2.12,2.12,0,0,1-1.36-.48,2.18,2.18,0,0,1-.33-3.06,92.09,92.09,0,0,0,9.35-14.09,2.18,2.18,0,1,1,3.83,2.07,96.78,96.78,0,0,1-9.79,14.75A2.18,2.18,0,0,1,554.93,201.46Zm19-40.84a3,3,0,0,1-.42,0,2.18,2.18,0,0,1-1.72-2.55,91.3,91.3,0,0,0,1.69-16.83,2.17,2.17,0,0,1,2.17-2.15h0a2.17,2.17,0,0,1,2.16,2.19,95.45,95.45,0,0,1-1.77,17.62A2.17,2.17,0,0,1,574,160.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M447.21,229.89a2.26,2.26,0,0,1-.8-.15c-2.76-1.1-5.49-2.33-8.1-3.66a2.18,2.18,0,0,1,2-3.88c2.5,1.27,5.1,2.45,7.74,3.5a2.17,2.17,0,0,1-.81,4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M482.1,185.7a46.17,46.17,0,0,1-6.07-.4h0a46.09,46.09,0,0,1-8.79-2.08h0l-.6-.22,2.2-6.13a39.77,39.77,0,0,0,8.07,2h0a39,39,0,0,0,43.72-32.74c0-.25.08-.5.11-.74a40,40,0,0,0,.35-5.21A39,39,0,0,0,443.41,135a39.65,39.65,0,0,0-.35,5.21,39.09,39.09,0,0,0,3.17,15.37l-6,2.59a45.53,45.53,0,1,1,87.35-18,46.28,46.28,0,0,1-.4,6.07A45.6,45.6,0,0,1,482.1,185.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1816.42,1168.41a25.34,25.34,0,0,1-25.28,25.25H424.27A25.34,25.34,0,0,1,399,1168.41L387.61,382.9c0-13.89,16.37-41,46.36-39l1335.86-34.56a63.69,63.69,0,0,1,65.36,65.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1791.47,1144.18a24,24,0,0,1-23.92,23.91H457.23a24,24,0,0,1-23.92-23.91L422.58,431.09c1.27-42.91,38.89-58.34,61.69-57.43l1280.35-34.35a44.71,44.71,0,0,1,45.89,45.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M447.48,804.08a2.18,2.18,0,0,1-2.18-2.14l-.85-57.84a2.18,2.18,0,0,1,2.15-2.2h0A2.17,2.17,0,0,1,448.8,744l.85,57.83a2.18,2.18,0,0,1-2.14,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M445.39,662.36a2.17,2.17,0,0,1-2.17-2.14L440,438.73c.07-14.86,4.65-26.74,13.62-35.33,16.3-15.63,41.8-14.84,42.88-14.8l408.84-11a2.21,2.21,0,0,1,2.23,2.11,2.19,2.19,0,0,1-2.12,2.24l-409,11c-1.17,0-24.88-.78-39.86,13.59-8.09,7.75-12.22,18.57-12.28,32.17l3.25,221.45a2.16,2.16,0,0,1-2.14,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1892.8,1258.86H350.32a34.6,34.6,0,0,1-34.51-34.5h0a34.61,34.61,0,0,1,34.51-34.51H1892.8a34.61,34.61,0,0,1,34.51,34.51h0A34.6,34.6,0,0,1,1892.8,1258.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1710.43,432.37H555.4c-24.52,0-44.39,20.91-44.39,46.72v595.39c0,25.81,19.87,46.73,44.39,46.73h1155c24.52,0,44.39-20.92,44.39-46.73V479.09C1754.82,453.28,1735,432.37,1710.43,432.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1184.62,964.93c-.25-3-3.48-5.7-8.94-7.82,5.94-3.17,9.22-6.56,8.94-9.89-.84-10.07-33.79-15.72-73.61-12.61s-71.42,13.79-70.58,23.86c.26,3.06,3.48,5.7,8.94,7.82-5.93,3.17-9.21,6.57-8.94,9.89.26,3.06,3.48,5.7,8.94,7.83-5.93,3.16-9.21,6.56-8.94,9.89.26,3.05,3.48,5.7,8.94,7.82-5.93,3.16-9.21,6.56-8.94,9.89.37,4.45,7,8,17.79,10.39a87.09,87.09,0,0,0,.27,10.88c1.56,18.57,23.13,33.12,51.66,33.12s53.22-19.84,53.5-38.47a90.25,90.25,0,0,0-.56-12.15c13.65-4.41,22-9.8,21.53-15-.25-3.05-3.48-5.7-8.94-7.82,5.94-3.16,9.22-6.56,8.94-9.89-.25-3-3.48-5.7-8.94-7.82C1181.62,971.66,1184.9,968.26,1184.62,964.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1092.58,1026a178.28,178.28,0,0,1-31.58-2.5.93.93,0,0,1-.76-1.09,1,1,0,0,1,1.12-.73c14,2.59,32.67,3.16,52.61,1.61,16.31-1.28,31.57-3.82,44.12-7.37a1,1,0,0,1,1.19.63.92.92,0,0,1-.65,1.15,234.61,234.61,0,0,1-44.51,7.43C1106.72,1025.72,1099.48,1026,1092.58,1026Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1092.78,1008.28c-15.36,0-29.09-1.4-38.78-4.07a.92.92,0,0,1-.65-1.14,1,1,0,0,1,1.18-.64c13.8,3.8,36,5,59.44,3.16,23.17-1.81,44.77-6.36,57.8-12.18a1,1,0,0,1,1.27.46.92.92,0,0,1-.47,1.23c-13.22,5.9-35.07,10.51-58.45,12.33C1106.83,1008,1099.64,1008.28,1092.78,1008.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1092.59,990.58c-16.59,0-31.11-1.64-40.88-4.76a.92.92,0,0,1-.61-1.17,1,1,0,0,1,1.21-.59c13.6,4.34,36.65,5.77,61.66,3.82,23.17-1.81,44.77-6.36,57.8-12.18a1,1,0,0,1,1.27.46.91.91,0,0,1-.47,1.22c-13.22,5.9-35.07,10.52-58.45,12.34C1106.72,990.3,1099.47,990.58,1092.59,990.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1092.71,972.86c-13.16,0-25.12-1-34.43-3a.92.92,0,0,1-.72-1.1.94.94,0,0,1,1.14-.7c14,3,34.14,3.78,55.27,2.13,23-1.79,44.46-6.29,57.5-12a1,1,0,0,1,1.27.46.91.91,0,0,1-.48,1.23c-13.23,5.83-35,10.39-58.14,12.2C1106.8,972.58,1099.6,972.86,1092.71,972.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1013.71,875.53A129,129,0,0,0,989.6,830c-23.71-28.92-62.38-87.72-67.14-168-6.92-116.75,100-175.2,197.66-167.26S1314,573,1303.5,681.61c-6.49,66.82-45.13,117.51-73.9,146.62A153.45,153.45,0,0,0,1191.24,894c-8.63,30.18-29.18,67.78-78,70.07C1050,967.05,1023.77,910,1013.71,875.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1129.36,940.8l34.15-215c.71-4.44,3-7.43,5-6.67s3.19,5,2.49,9.43c0,.12,0,.26-.07.38l-38.9,213c-.29,1.6-1.13,2.61-1.88,2.26S1129.12,942.35,1129.36,940.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1093.91,942.51l-34.15-215c-.71-4.44-3-7.42-5-6.66s-3.19,5-2.49,9.43c0,.11,0,.26.07.38l38.9,213c.29,1.61,1.13,2.62,1.88,2.26S1094.15,944.06,1093.91,942.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1163.27,707.33a3.65,3.65,0,0,0-4.48-1.13l-19,8.6-6.6-18.21a4,4,0,0,0-2.32-2.25,4.78,4.78,0,0,0-5.84,1.75l0,0-15.64,27.61-14.52-39.3,0-.06a4.5,4.5,0,0,0-2.2-2.4,5.84,5.84,0,0,0-7.18,1.37l-21.86,29.13a2.51,2.51,0,0,0,.77,3.68,3.76,3.76,0,0,0,4.65-.49l19.25-20.78,17.33,37.37,0,0a3,3,0,0,0,1.52,1.45,3.7,3.7,0,0,0,4.54-1.13l16.73-26,6.29,13.15.06.11a1.51,1.51,0,0,0,.15.28,3.65,3.65,0,0,0,4.48,1.13l22.58-10.21A2.57,2.57,0,0,0,1163.27,707.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1230.34,799.48a3.23,3.23,0,0,1-1.94-.63,3.08,3.08,0,0,1-.68-4.41,244,244,0,0,0,15.91-23.4,3.33,3.33,0,0,1,4.46-1.15,3.1,3.1,0,0,1,1.19,4.31,248.47,248.47,0,0,1-16.32,24A3.28,3.28,0,0,1,1230.34,799.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1258.44,752.8a3.28,3.28,0,0,1-1.3-.26,3.11,3.11,0,0,1-1.69-4.15c36.22-80.75,5-148.82,4.63-149.5a3.11,3.11,0,0,1,1.61-4.18,3.31,3.31,0,0,1,4.32,1.55c.34.7,32.84,71.22-4.58,154.64A3.26,3.26,0,0,1,1258.44,752.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1219.77,564.21a10.87,10.87,0,0,1-10.87,10.87H1024.06a10.87,10.87,0,0,1-10.87-10.87h0a10.87,10.87,0,0,1,10.87-10.87H1208.9a10.87,10.87,0,0,1,10.87,10.87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 970.3,
    cy: 430.88,
    r: 44.13,
    transform: "translate(328.02 1276.23) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 970.3,
    cy: 430.88,
    r: 42.66,
    transform: "translate(-20.48 812.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M935.12,415.33a2.1,2.1,0,0,1-1-.23,2.17,2.17,0,0,1-1-2.92,41.39,41.39,0,0,1,37.12-22.86,42.86,42.86,0,0,1,7.5.67,2.18,2.18,0,0,1-.78,4.29,37.22,37.22,0,0,0-39.95,19.86A2.2,2.2,0,0,1,935.12,415.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 971.23,
    cy: 431.81,
    r: 36.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M967.69,458.65v-3.93a31.85,31.85,0,0,1-11-2.39,2.27,2.27,0,0,1-1.26-2.68l1-3.66a2.28,2.28,0,0,1,3.11-1.5,26.66,26.66,0,0,0,10.17,2.14c3.95,0,6.89-1.34,6.89-4.08,0-2.47-2.27-3.94-7.76-5.41-7.82-2.14-13.43-5.55-13.43-12.44,0-6.21,4.54-11,12.43-12.23v-3.93a2.3,2.3,0,0,1,2.29-2.29h2.31a2.3,2.3,0,0,1,2.29,2.29v3.53a29,29,0,0,1,8.73,1.57,2.27,2.27,0,0,1,1.43,2.75l-.92,3.38a2.27,2.27,0,0,1-3,1.54,23.94,23.94,0,0,0-8.57-1.55c-4.68,0-6,1.93-6,3.67,0,2.14,2.81,3.61,8.89,5.48,8.69,2.61,12.3,6.22,12.3,12.71,0,5.95-4.41,11.29-13,12.63v4.4a2.29,2.29,0,0,1-2.28,2.29H970A2.29,2.29,0,0,1,967.69,458.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 1087.96,
    cy: 341.51,
    r: 76.82,
    transform: "translate(546.87 1345.26) rotate(-79.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 1087.96,
    cy: 341.51,
    r: 74.26,
    transform: "matrix(0.17, -0.98, 0.98, 0.17, 562.87, 1353.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1026.73,312.84a2.15,2.15,0,0,1-1-.24,2.18,2.18,0,0,1-1-2.92,70.43,70.43,0,0,1,63.17-38.9,71.5,71.5,0,0,1,12.76,1.15,2.18,2.18,0,1,1-.78,4.28,67.4,67.4,0,0,0-12-1.08,66.11,66.11,0,0,0-59.29,36.51A2.17,2.17,0,0,1,1026.73,312.84Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 1089.58,
    cy: 343.13,
    r: 62.85,
    transform: "translate(-33.76 135.7) rotate(-7.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1083.41,389.86V383a55.88,55.88,0,0,1-19.18-4.16,4,4,0,0,1-2.19-4.68l1.74-6.36a4,4,0,0,1,5.41-2.61,46.35,46.35,0,0,0,17.72,3.73c6.86,0,12-2.33,12-7.1,0-4.31-4-6.87-13.5-9.43-13.61-3.72-23.39-9.66-23.39-21.64,0-10.83,7.92-19.09,21.65-21.3v-6.84a4,4,0,0,1,4-4h4a4,4,0,0,1,4,4v6.14a50.67,50.67,0,0,1,15.21,2.73,4,4,0,0,1,2.48,4.79l-1.6,5.89a4,4,0,0,1-5.24,2.68,41.65,41.65,0,0,0-14.92-2.71c-8.15,0-10.47,3.38-10.47,6.4,0,3.73,4.89,6.29,15.48,9.55,15.12,4.54,21.41,10.82,21.41,22.11,0,10.36-7.68,19.67-22.58,22v7.66a4,4,0,0,1-4,4h-4A4,4,0,0,1,1083.41,389.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 1140.94,
    cy: 513.09,
    r: 79.04,
    transform: "translate(358.06 1488.85) rotate(-75.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 1140.94,
    cy: 513.09,
    r: 76.42,
    transform: "translate(-28.63 957.05) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1077.93,483.52a2.15,2.15,0,0,1-1-.24,2.18,2.18,0,0,1-1-2.92,72.4,72.4,0,0,1,65-40,73.67,73.67,0,0,1,13.12,1.18,2.18,2.18,0,1,1-.78,4.28,68.49,68.49,0,0,0-73.41,36.49A2.17,2.17,0,0,1,1077.93,483.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 1142.61,
    cy: 514.75,
    r: 64.68,
    transform: "translate(292.95 1435.94) rotate(-71.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1136.26,562.83v-7a57.6,57.6,0,0,1-19.74-4.28,4.08,4.08,0,0,1-2.25-4.81l1.78-6.56a4.1,4.1,0,0,1,5.57-2.68,47.76,47.76,0,0,0,18.23,3.84c7.07,0,12.34-2.4,12.34-7.31,0-4.43-4.07-7.06-13.89-9.7-14-3.83-24.07-9.94-24.07-22.27,0-11.14,8.14-19.64,22.27-21.92v-7a4.1,4.1,0,0,1,4.1-4.1h4.13a4.09,4.09,0,0,1,4.1,4.1v6.32a52.18,52.18,0,0,1,15.65,2.81,4.07,4.07,0,0,1,2.55,4.92l-1.64,6.06A4.09,4.09,0,0,1,1160,496a42.8,42.8,0,0,0-15.35-2.78c-8.38,0-10.77,3.47-10.77,6.58,0,3.84,5,6.47,15.92,9.82,15.57,4.67,22,11.14,22,22.75,0,10.66-7.91,20.24-23.24,22.64v7.87a4.09,4.09,0,0,1-4.1,4.1h-4.13A4.1,4.1,0,0,1,1136.26,562.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 1242.34,
    cy: 405.41,
    r: 57.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 1242.34,
    cy: 405.41,
    r: 55.99,
    transform: "translate(77.2 997.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1196.17,384.33a2.26,2.26,0,0,1-1-.23,2.16,2.16,0,0,1-1-2.92,53.61,53.61,0,0,1,48.1-29.63,54.48,54.48,0,0,1,9.72.88,2.18,2.18,0,1,1-.78,4.28,49.55,49.55,0,0,0-53.16,26.42A2.18,2.18,0,0,1,1196.17,384.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 1243.56,
    cy: 406.63,
    r: 47.39,
    transform: "translate(338.37 1351.31) rotate(-64.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1238.91,441.86v-5.15a42.18,42.18,0,0,1-14.46-3.14,3,3,0,0,1-1.65-3.52l1.31-4.81a3,3,0,0,1,4.08-2,34.93,34.93,0,0,0,13.36,2.81c5.17,0,9-1.76,9-5.35,0-3.25-3-5.18-10.17-7.11-10.27-2.81-17.64-7.28-17.64-16.32,0-8.16,6-14.39,16.32-16.05V376.1a3,3,0,0,1,3-3h3a3,3,0,0,1,3,3v4.63a38.3,38.3,0,0,1,11.46,2.06,3,3,0,0,1,1.87,3.61l-1.2,4.44a3,3,0,0,1-4,2,31.23,31.23,0,0,0-11.24-2c-6.15,0-7.9,2.54-7.9,4.82,0,2.81,3.68,4.74,11.67,7.2,11.4,3.42,16.14,8.16,16.14,16.67,0,7.81-5.79,14.83-17,16.58v5.77a3,3,0,0,1-3,3h-3A3,3,0,0,1,1238.91,441.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1215.42,588.13H1013.19a3.26,3.26,0,0,1,0-6.52h202.23a3.26,3.26,0,0,1,0,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1620.38,598.31s27.18,9.06,44.79,47.88c4.81,10.62,30.95,12.5,33.65,34.28a25,25,0,0,0,20.91,22c27.89,4.27,70.88,18.75,77.75,67.18,5.25,37-13.59,51-33.37,55.83-14.52,3.56-24.17,17.69-21.24,32.36,2.82,14.06-1.38,30.32-25.75,43.18C1662.52,929.8,1608,832.73,1608,832.73l-11.18-169.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1444.91,593.05s68,107.58,148.9,128.37c0,0-15.76,44.88-27.92,50,0,0-99.51-83-125.09-163.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1770.31,1281.18l2.2,18.12a7.49,7.49,0,0,0,6.57,6.55,116.4,116.4,0,0,0,24.25.38,6.41,6.41,0,0,0,5.39-8.31c-2.23-7-6.3-17.5-12.16-23.68h-20.11A6.19,6.19,0,0,0,1770.31,1281.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1612.85,1068.88l-3.4,20s11.37,115.1,13.39,161.14a36.15,36.15,0,0,1-5.34,20.51l-19.76,32.08,50.22-29.63,1-6.13-8.22-11.3,10.76-128.94a39.5,39.5,0,0,0-4.5-21.88l-10.39-19.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1594.43,1307.22h16a9.67,9.67,0,0,0,7.66-3.75c5-6.5,15.34-19.16,20.29-19.49,6.66-.45,5.81,23.24,5.81,23.24H1648l4.73-29.43a17.42,17.42,0,0,0-9.15-18.21h0s-1.52,11.26-9.78,16.24-33.6,22.83-33.6,22.83a22.7,22.7,0,0,0-6.52.17C1588.59,1299.73,1589.29,1307.22,1594.43,1307.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1681.63,1078.36s66.57,126.28,77.15,155.11,14.29,52.88,14.43,55.16c.22,3.56,4.65,7,16.85,7,6.29,0,9.38-2.52,10.89-5a7.12,7.12,0,0,0,.27-6.89c-3.85-7.79-16.07-32.7-20.6-44-5.4-13.49-17-74.61-23.4-95.86s-13.58-44.3-41.34-65.53C1715.88,1078.36,1696.82,1059.7,1681.63,1078.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1639.57,871.45c-17.17-72.76,26.33-113.92,26.33-113.92-27.45-26.34-77.46-38.33-77.46-38.33s-47.72,34.89-42.06,62.19c3.32,16,33.55,95.87,33.55,95.87S1607.88,890.49,1639.57,871.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1677.65,907.48c-7-21.06-38.08-36-38.08-36-31.69,19-59.64,5.81-59.64,5.81s-6.27,24-2,46.23,31.47,165.35,31.47,165.35c42.77,8.67,108.54-8.72,108.54-8.72C1690.75,1031.76,1684.63,928.53,1677.65,907.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1619.64,671.11l14,62.71c1.34,5.53-3.7,4.62-9.28,3.57-9.15-1.72-20.93-5.28-24.87-12.39a6.59,6.59,0,0,1-.72-2.37l-6-43.48a7.82,7.82,0,0,1,4.58-8.21l11.57-5.13A7.81,7.81,0,0,1,1619.64,671.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1592.9,614S1578,624,1571.65,649.63s4,34.81,14.63,34.25,26.07-3.86,39.43-22.24S1612.38,601.65,1592.9,614Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1612.23,651.31s5.45-36.71-25-31.1l-6.17,6.42s-14.92-16.81,1.6-29.51,39.42-9.44,52.1,13.68,17.27,39.37,6.65,53.74-18.62,2-18.62,2,4.87-12.43.83-17.77-9.26,3.1-9.26,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1616.4,654.45s2.69-18.89,12.34-13.49-3.48,17.65-8.74,21.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1445.38,615.19c-.21,2.22,8,3.76,10.67-5.7-.72-4.11-2-22.1-5.16-24.89-16.77-14.89-46.68-31.63-46.68-31.63a6.11,6.11,0,0,0,1,8.47l14.93,10.08c-1.56,5.16-3.83,9.72-4.09,15.61a17.52,17.52,0,0,0,4.42,12.21c3,3.39,7,7.78,10.58,11.11A17.27,17.27,0,0,0,1445.38,615.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1437.36,607.82l2.09-.86c-.3-.74-7.46-18.13-10.91-21.74-1.34-1.39-2-2.6-1.92-3.58a2.63,2.63,0,0,1,.84-1.65l12.18,6.51,5.35,8.38,1.91-1.22-5.67-8.88-14.07-7.52-.58.48a5.29,5.29,0,0,0-2.23,3.77c-.1,1.65.74,3.38,2.55,5.28C1429.52,589.53,1435.34,602.9,1437.36,607.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1665.9,757.53s77.29,158.69,105.28,172.56c0,0,28.42,3,45.81,8.23a4.55,4.55,0,0,1-.18,8.74c-12.11,3.31-32.18,6.07-50.57-3.92,0,0,9.88,14.81,4.12,20.58,0,0-13.17-15.64-18.11-20.58-4.35-4.34-83.5-90.63-116.77-142.67-2.69-4.21-.83-16.7,1-21.33C1640.82,768.49,1650.35,751.48,1665.9,757.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1607.37,600.34c6.54,2.14,12.39,6.07,17.7,10.4a74,74,0,0,1,25.61,43.46,95.17,95.17,0,0,0,2.24,10.26,22.79,22.79,0,0,0,5.25,9.4,33.87,33.87,0,0,0,8.69,6.22c3.1,1.66,6.25,3.1,9.21,4.77a37.77,37.77,0,0,1,18.21,23.22c.94,3.28,1.66,6.71,2.9,10.08a20.48,20.48,0,0,0,6,9,26.17,26.17,0,0,0,9.67,4.82,97.78,97.78,0,0,0,10.3,2.15,84.92,84.92,0,0,1,19.73,5.52c12.5,5.28,24,14.14,30.12,26.33a34,34,0,0,1,3.62,19.63,29.33,29.33,0,0,1-8.85,17.75,21.9,21.9,0,0,1-8.66,5,23,23,0,0,1-10.05.47c-6.66-1-13.06-5.31-15.57-11.74l-.53.2c2.46,6.72,9,11.3,15.92,12.53a24.14,24.14,0,0,0,10.56-.28,23.26,23.26,0,0,0,9.3-5.1c5.39-4.74,8.52-11.6,9.57-18.59a35.85,35.85,0,0,0-3.56-20.72,51.26,51.26,0,0,0-13-16.54,70.53,70.53,0,0,0-18-11,87.69,87.69,0,0,0-20.2-5.75,95,95,0,0,1-10-2.12,23.76,23.76,0,0,1-8.8-4.4,18.54,18.54,0,0,1-5.36-8c-1.18-3.14-1.91-6.51-2.89-9.89a40,40,0,0,0-10.78-18.18,39.47,39.47,0,0,0-8.58-6.31c-3.08-1.73-6.25-3.15-9.27-4.76a31.79,31.79,0,0,1-8.18-5.78,20.7,20.7,0,0,1-4.88-8.53,96.42,96.42,0,0,1-2.31-10,74.44,74.44,0,0,0-26.8-43.89c-5.48-4.28-11.46-8.11-18.18-10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1644.22,647.83a99.44,99.44,0,0,0,1.29,13.4,37.3,37.3,0,0,0,4.51,12.85,25.49,25.49,0,0,0,4.37,5.4,46.9,46.9,0,0,0,5.39,4.24,106.16,106.16,0,0,1,10.7,7.83c6.61,5.68,12.16,12.77,13.89,21.25,2,8.4,1.44,17.71,5.19,26.53a28.53,28.53,0,0,0,8.76,11,45,45,0,0,0,12.17,6.57c8.67,3.12,17.64,4.23,26.24,6.18s17,5.17,23.08,11.47c2.92,3.1,5.5,7,5.55,11.23s-1.95,8.45-3.91,12.42l.5.26c2.21-3.83,4.54-7.92,4.71-12.67a14.64,14.64,0,0,0-1.57-6.8,26.53,26.53,0,0,0-3.87-5.74c-6.25-6.94-15.16-10.55-23.85-12.78s-17.66-3.36-25.81-6.45-15.67-8.22-19-16c-3.47-7.77-3.11-17-5.24-25.89a35.77,35.77,0,0,0-5.69-12.66,48.37,48.37,0,0,0-9.48-9.94c-6.89-6-16-9-20.56-16.44a35.75,35.75,0,0,1-4.85-12.09,122.62,122.62,0,0,1-2-13.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2061.1,491.19l4.7,7.32a3.26,3.26,0,0,1-5.47,3.53l-4.72-7.31a3.26,3.26,0,0,1,5.48-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2073.84,511.6l4.38,7.52a3.24,3.24,0,0,1-5.59,3.27l-4.4-7.51a3.24,3.24,0,1,1,5.6-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2085.65,532.56l4,7.71a3.22,3.22,0,0,1-5.71,3l-4-7.71a3.23,3.23,0,0,1,5.72-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2096.09,554.09l3.8,7.91a3.15,3.15,0,1,1-5.7,2.67l-3.6-7.9a3.15,3.15,0,0,1,1.41-4.26c1.61-.74,4.09,0,4.09,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2107,576.18l2.71,8.09a3.34,3.34,0,0,1-6.26,2.33l-3.23-8.1c-.65-1.64.58-3.49,2.22-4.13s2.38.16,4.56,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2113.49,598.78l3.12,8.28a3,3,0,1,1-5.68,1.94l-2.62-8.27c-.54-1.66,0-3.45,1.61-4s3.57.37,3.57,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2122.19,621.89l1.68,8.42a3.31,3.31,0,0,1-2.51,3.83,3.26,3.26,0,0,1-3.92-2.29l-2.18-8.42c-.43-1.69,1-3.41,2.69-3.83s2.06.59,4.24,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2126.54,645.41l1.59,8.56a3.11,3.11,0,1,1-6.11,1.11l-1.53-8.56a3.1,3.1,0,0,1,2.47-3.65c1.7-.3,3.58.83,3.58,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2130.89,669.27l.62,8.65a3.21,3.21,0,0,1-2.9,3.42,3.17,3.17,0,0,1-3.49-2.77l-.94-8.65a3.32,3.32,0,0,1,3-3.43c1.71-.18,3.68,1.06,3.68,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2133.06,693.34l-.16,8.7a3.26,3.26,0,0,1-3.2,3.18,3.18,3.18,0,0,1-3.28-3l-.31-8.69a3.43,3.43,0,0,1,3.38-3.19c1.72-.05,3.57,1.3,3.57,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2133.06,717.49l-.77,8.68a3.26,3.26,0,0,1-3.41,2.93,3.16,3.16,0,0,1-3-3.22l.36-8.68a3.44,3.44,0,0,1,6.83.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2130.89,741.57l-1.23,8.62a3.12,3.12,0,0,1-3.48,2.66,3.08,3.08,0,0,1-2.7-3.41l1.05-8.63a3.2,3.2,0,0,1,3.55-2.67,3.35,3.35,0,0,1,2.81,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2126.54,765.43l-1.47,8.53a2.92,2.92,0,0,1-3.46,2.38,3,3,0,0,1-2.32-3.58l1.74-8.53a2.82,2.82,0,0,1,3.35-2.39c1.65.33,2.16,1.94,2.16,3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2122.19,789l-2.55,8.39a3.14,3.14,0,0,1-3.83,2.11,3.06,3.06,0,0,1-2.17-3.72l2.28-8.39a3.26,3.26,0,0,1,3.94-2.12c1.61.44,2.33,2.11,2.33,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2115.66,812.08l-3.38,8.19a3.27,3.27,0,0,1-4.07,1.82,3.07,3.07,0,0,1-1.93-3.85l2.86-8.19a3.51,3.51,0,0,1,4.28-1.83,3.92,3.92,0,0,1,2.24,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2107,834.6l-4,7.95a3.26,3.26,0,0,1-4.17,1.51,3,3,0,0,1-1.63-3.94l3.47-8a3.48,3.48,0,0,1,4.37-1.53c1.51.67,1.94,2.44,1.94,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2095.75,856.41l-4.1,7.66a3,3,0,0,1-5.25-2.8l4.1-7.67a3,3,0,1,1,5.25,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2083.88,877.4l-4.63,7.35a3,3,0,0,1-5-3.14l4.62-7.37a3,3,0,0,1,5,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2070.6,897.51l-5.12,7a2.94,2.94,0,0,1-4.75-3.46l5.11-7a2.94,2.94,0,1,1,4.76,3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2056,916.69l-5.55,6.69a2.92,2.92,0,0,1-4.5-3.72l5.55-6.7a2.93,2.93,0,1,1,4.51,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2040.29,934.93l-6,6.35a2.9,2.9,0,0,1-4.24-4L2036,931a2.91,2.91,0,1,1,4.25,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2023.52,952.2l-6.29,6a2.89,2.89,0,0,1-4-4.17l6.28-6a2.89,2.89,0,1,1,4,4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2005.83,968.53l-6.59,5.67a2.87,2.87,0,0,1-3.74-4.35l6.59-5.68a2.88,2.88,0,0,1,3.75,4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1987.34,983.92l-6.86,5.34a2.85,2.85,0,1,1-3.5-4.5l6.86-5.34a2.85,2.85,0,0,1,3.51,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1968.14,996.94l-7.1,5.75a2.79,2.79,0,0,1-4-.32,2.62,2.62,0,0,1,.68-3.76l7.09-4.94c1.28-.9,3.05-1.28,4,0s.6,3.28-.67,3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1948.32,1012.16l-7.32,4.62a2.84,2.84,0,0,1-3-4.79l7.31-4.73a2.85,2.85,0,0,1,3.9.92c.84,1.31.47,1.8-.84,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1927.94,1023l-7.51,5.25c-1.33.79-3,.77-3.82-.57a2.55,2.55,0,0,1,1-3.61l7.49-4.31c1.34-.78,3.05-1.13,3.84.2s.34,3-1,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1907.07,1036.08l-7.67,4.39a2.74,2.74,0,0,1-3.76-1,2.7,2.7,0,0,1,1.13-3.69l7.66-4.08a2.7,2.7,0,0,1,3.77.87c.73,1.35.23,3.51-1.13,3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1885.77,1047l-7.81,4.22a2.7,2.7,0,0,1-3.7-1.06,2.66,2.66,0,0,1,1.26-3.6l7.81-3.79c1.37-.67,3-.48,3.7.89s.11,3.34-1.26,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1864.09,1057.82l-7.94,3.67a2.7,2.7,0,1,1-2.25-4.91l7.94-3.55a2.7,2.7,0,0,1,3.63,1.27c.62,1.38,0,1.35-1.38,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1842.06,1066.52l-8,3.84a2.63,2.63,0,0,1-3.56-1.22,2.58,2.58,0,0,1,1.5-3.42l8-3.22c1.39-.57,3-.42,3.56,1s-.1,3-1.5,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1819.73,1075.22l-8.16,3.63a2.56,2.56,0,0,1-3.47-1.29,2.53,2.53,0,0,1,1.59-3.32l8.16-3c1.4-.52,3-.38,3.49,1s-.2,2.91-1.6,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1797.13,1083.92l-8.25,3.06a2.58,2.58,0,1,1-1.71-4.86l8.25-2.73a2.55,2.55,0,0,1,3.41,1.41c.48,1.41-.28,3.12-1.7,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1774.28,1090.44l-8.33,3.23c-1.41.42-2.9,0-3.32-1.43a2.47,2.47,0,0,1,1.79-3.14l8.33-2.41c1.41-.43,2.91-.31,3.33,1.1a1.9,1.9,0,0,1-1.79,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1751.22,1097l-8.41,3c-1.41.37-2.87-.07-3.24-1.49a2.44,2.44,0,0,1,1.88-3l8.4-2.15c1.42-.38,2.88-.28,3.26,1.14a1.86,1.86,0,0,1-1.89,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1728,1103.49l-8.47,2.47a2.46,2.46,0,1,1-1.2-4.76l8.47-1.92c1.42-.33,2.84.08,3.18,1.5a2.09,2.09,0,0,1-2,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1704.52,1107.84l-8.53,2.62c-1.41.29-2.79-.17-3.08-1.59A2.4,2.4,0,0,1,1695,1106l8.52-1.59c1.43-.29,2.81-.24,3.1,1.18s-.64,2.23-2.06,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1680.93,1114.36l-8.58,1.31a2.64,2.64,0,0,1-.85-5.21l8.58-1.45a2.68,2.68,0,0,1,3,2.24c.24,1.43-.72.93-2.14,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1657.21,1116.53l-8.62,1.78a2.37,2.37,0,0,1-2.9-1.91,2.42,2.42,0,0,1,2.22-2.73l8.62-1.07c1.42-.19,2.72.21,2.91,1.63a2,2,0,0,1-2.23,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1633.38,1120.88l-8.66.76a2.61,2.61,0,0,1-2.8-2.36,2.58,2.58,0,0,1,2.29-2.83l8.66-.88a2.66,2.66,0,0,1,2.82,2.4c.14,1.41-.89.74-2.31,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1609.5,1123.06l-8.68.55a2.59,2.59,0,0,1-.38-5.16l8.67-.67a2.61,2.61,0,0,1,2.74,2.44c.11,1.41-.94.66-2.35,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1585.57,1123.06l-8.69,1.15a2.27,2.27,0,0,1-2.65-2,2.37,2.37,0,0,1,2.39-2.48l8.69-.36c1.4-.08,2.59.33,2.67,1.73s-1,2-2.4,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1561.61,1125.23l-8.69.36a2.46,2.46,0,0,1-2.58-2.38,2.49,2.49,0,0,1,2.44-2.55l8.7-.22a2.42,2.42,0,0,1,2.58,2.33,2.38,2.38,0,0,1-2.45,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1537.63,1125.23h-8.7a2.22,2.22,0,0,1-2.49-2.15,2.34,2.34,0,0,1,2.49-2.32l8.7.07a2.22,2.22,0,1,1,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1513.64,1125.23H1505a2.38,2.38,0,0,1-2.41-2.42,2.42,2.42,0,0,1,2.54-2.35l8.69.25a2.3,2.3,0,0,1,2.42,2.32,2.32,2.32,0,0,1-2.55,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1489.68,1123.06l-8.69.43c-1.35-.07-2.39-.77-2.32-2.13a2.28,2.28,0,0,1,2.58-2.1l8.69.57c1.36.07,2.41.38,2.33,1.74s-1.23,1.49-2.59,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1465.74,1123.06l-8.67-.56a2.37,2.37,0,0,1-2.23-2.56,2.4,2.4,0,0,1,2.63-2.19l8.67.72a2.31,2.31,0,0,1,2.24,2.49,2.42,2.42,0,0,1-2.64,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1441.85,1120.88l-8.64-.8a2.36,2.36,0,0,1-2.15-2.6,2.4,2.4,0,0,1,2.68-2.11l8.64,1a2.28,2.28,0,0,1,2.15,2.53,2.42,2.42,0,0,1-2.68,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1418,1116.53l-8.61-.31c-1.31-.19-2.23-1-2.05-2.27a2.26,2.26,0,0,1,2.72-1.83l8.61,1.31c1.32.19,2.24.56,2.06,1.89s-1.4,3.39-2.72,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1394.31,1114.36l-8.57-1.27a2.28,2.28,0,0,1-2-2.65,2.35,2.35,0,0,1,2.75-1.91l8.58,1.48a2.22,2.22,0,0,1,2,2.58c-.22,1.3-1.46,1.77-2.76,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1370.71,1110l-8.53-1.48a2.26,2.26,0,0,1-1.85-2.68,2.33,2.33,0,0,1,2.79-1.79l8.53,1.74a2.15,2.15,0,0,1,1.86,2.57c-.26,1.29-1.51,1.64-2.8,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1347.24,1105.66l-8.46-2.06a2.4,2.4,0,0,1-1.76-2.87,2.37,2.37,0,0,1,2.83-1.78l8.47,2a2.42,2.42,0,0,1,1.76,2.9,2.67,2.67,0,0,1-2.83,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1323.94,1099.14l-8.4-1.92a2.17,2.17,0,0,1-1.65-2.69,2.29,2.29,0,0,1,2.86-1.58l8.4,2.28a2,2,0,0,1,1.66,2.56c-.33,1.25-1.61,1.35-2.86,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1300.83,1092.61l-8.33-2.13a2.12,2.12,0,0,1-1.55-2.69,2.26,2.26,0,0,1,2.89-1.46l8.33,2.54a2,2,0,0,1,1.56,2.54c-.37,1.23-1.66,1.2-2.89,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1277.93,1086.09l-8.24-2.7a2.28,2.28,0,1,1,1.46-4.31l8.25,2.76a2.25,2.25,0,0,1,1.46,2.86c-.41,1.21-1.72,1.39-2.92,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1255.27,1077.39l-8.16-2.54a2,2,0,0,1-1.34-2.69,2.22,2.22,0,0,1,2.93-1.23l8.16,3.08a1.82,1.82,0,0,1,1.35,2.48c-.44,1.19-1.75.9-2.94.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1232.86,1068.69l-8-2.73a2,2,0,0,1-1.25-2.68,2.21,2.21,0,0,1,3-1.11l8.06,3.34c1.17.47,1.73,1.28,1.25,2.45s-1.79.73-3,.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1210.74,1060l-8-3.27a2.11,2.11,0,0,1-1.14-2.84,2.22,2.22,0,0,1,3-1.08l8,3.55a2,2,0,0,1,1.15,2.73c-.5,1.14-1.83.91-3,.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1188.92,1049.12l-7.87-2.95a1.84,1.84,0,0,1-1.07-2.59,2.16,2.16,0,0,1,3-.89l7.88,3.78c1.12.52,1.6,1.15,1.08,2.27s-1.86,2.56-3,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1167.3,1040.43l-7.82-3.84a2.23,2.23,0,0,1,1.93-4l7.83,3.79a2.26,2.26,0,0,1,1,3c-.54,1.1-1.86,1.07-3,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1145.81,1029.55l-7.78-3.75a2.12,2.12,0,0,1-1-2.88,2.18,2.18,0,0,1,2.94-.95l7.79,3.88a2.06,2.06,0,0,1,1,2.83c-.54,1.09-1.86.87-3,.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1124.41,1018.68l-7.76-3.74a2.05,2.05,0,0,1-1-2.82,2.14,2.14,0,0,1,2.92-.91l7.77,3.95a2,2,0,0,1,1,2.74c-.54,1.08-1.86.78-2.93.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1103.08,1007.81l-7.75-3.76a2,2,0,0,1-.93-2.81,2.14,2.14,0,0,1,2.9-.89l7.75,4a2,2,0,0,1,1,2.72c-.55,1.06-1.85.75-2.92.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1081.79,996.94l-7.75-3.8a2,2,0,0,1-.92-2.79,2.12,2.12,0,0,1,2.88-.88l7.75,4a2,2,0,0,1,.93,2.72c-.54,1.06-1.83.77-2.89.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1060.5,986.06l-7.75-3.79a2,2,0,0,1-.93-2.77,2.1,2.1,0,0,1,2.85-.89l7.76,4a2,2,0,0,1,.94,2.71c-.54,1.05-1.82.78-2.87.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1039.17,975.19l-7.77-3.73a2,2,0,0,1-.94-2.74,2.09,2.09,0,0,1,2.83-.89l7.78,3.92a1.94,1.94,0,0,1,.94,2.67c-.52,1-1.79.77-2.84.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1017.78,964.32l-7.8-3.57a1.94,1.94,0,0,1-1-2.67,2.06,2.06,0,0,1,2.79-.88l7.81,3.86a1.82,1.82,0,0,1,1,2.55c-.51,1-1.77.71-2.8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M996.31,953.45l-7.85-3.29a1.81,1.81,0,0,1-1-2.52,2,2,0,0,1,2.76-.86l7.85,3.79a1.62,1.62,0,0,1,1,2.33c-.5,1-1.74.55-2.77.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M974.71,942.57l-7.9-2.82a1.63,1.63,0,0,1-1-2.32,2,2,0,0,1,2.72-.81l7.91,3.72c1,.47,1.49.94,1,2s-1.69,2.44-2.73.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M953,933.88l-8-3.26a1.91,1.91,0,0,1-1-2.57,2,2,0,0,1,2.68-1l8,3.5a1.81,1.81,0,0,1,1.06,2.48c-.45,1-1.65.84-2.69.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M931,925.18l-8-3.45a2.1,2.1,0,0,1-1.1-2.7,2,2,0,0,1,2.63-1.14l8,3.29a2.17,2.17,0,0,1,1.11,2.77c-.43,1-1.61,1.23-2.65,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M908.91,914.3,900.79,912c-1-.39-1.54-1.13-1.15-2.17a1.91,1.91,0,0,1,2.58-.94l8.12,3.21c1,.4,1.56.78,1.16,1.81s-1.56,2.55-2.59.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M886.57,907.78l-8.2-3,0,0a2,2,0,0,1-1.21-2.55,2,2,0,0,1,2.53-1.22l8.22,2.88a2.08,2.08,0,0,1,1.22,2.62c-.37,1-1.5,1.3-2.54,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M864,899.08,855.67,897a1.75,1.75,0,0,1-1.3-2.24,1.91,1.91,0,0,1,2.45-1.2l8.32,2.59c1,.32,1.63,1,1.31,2.06s-1.42.9-2.46.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M841.11,892.56l-8.43-1.8a1.77,1.77,0,0,1-1.4-2.19,1.89,1.89,0,0,1,2.37-1.31l8.43,2.2c1,.27,1.68,1,1.41,2s-1.33,1.06-2.38,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M818,886l-8.52-.95c-1-.22-1.71-.82-1.49-1.87a1.8,1.8,0,0,1,2.28-1.29l8.51,1.87c1,.22,1.72.46,1.51,1.51S819,886,818,886Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M794.55,881.69l-8.59-.62c-1-.17-1.75-.77-1.59-1.82a1.8,1.8,0,0,1,2.19-1.4l8.59,1.45c1.05.17,1.76.45,1.6,1.49s-1.15.9-2.2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M771,879.51l-8.65-.8a1.82,1.82,0,0,1-1.67-2,1.85,1.85,0,0,1,2.08-1.64l8.65,1a1.78,1.78,0,0,1,1.68,2,1.88,1.88,0,0,1-2.09,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M747.23,877.34l-3.88-.14a1.82,1.82,0,0,1-1.75-1.94,1.85,1.85,0,0,1,2-1.72l3.88.26a1.78,1.78,0,0,1,1.76,1.89,1.84,1.84,0,0,1-2,1.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.8,
    y: 1113.85,
    width: 16.52,
    height: 178.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M389.71,1296H534.4v-7.9a2.86,2.86,0,0,0-2.85-2.86H392.79a3.08,3.08,0,0,0-3.08,3.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 362.35,
    y: 1071.31,
    width: 193.34,
    height: 54.83,
    rx: 18.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M608.5,1238.25s53.41,23,50.35,47.07c0,0-55.21-10.58-65.09-26.36s-4.44-24.92-4.44-24.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M595.42,1212l-2.71,23.43a7.76,7.76,0,0,0,4.9,8.24,20.27,20.27,0,0,0,6.77,1,9,9,0,0,0,8.77-6.58l5.25-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M478.75,1032.21s98.23-4.55,147.11,24-2.48,165.31-2.48,165.31-12.77,2.75-31.15-7.08c0,0,26.24-100.15-19.34-117.57C521.65,1077.24,468.65,1082,468.65,1082l9.82-46.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M648.11,1274.76c-11.17-2.45-44.29-16.17-49.32-16s-12.16,7.72-12.16,7.72-1.23,4.12,2.37,10c8.54,6.65,26.92,18.87,48.3,20.21,15.72,1,25.18-5.27,30.59-11.34A43.77,43.77,0,0,0,648.11,1274.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M637.3,1296.74c-21.38-1.34-39.76-13.56-48.3-20.21,2.43,4,7.07,8.81,15.78,13.73,21.6,12.21,57.3,10.43,64.37,7.68,5.67-2.2,3.92-7.5-1.26-12.54C662.48,1291.47,653,1297.73,637.3,1296.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M574.9,1254.23c.74,2.76,8.56,11.07,13.08,15.7a8.9,8.9,0,0,0,8.28,2.49,22.39,22.39,0,0,0,5.92-2.08,5.77,5.77,0,0,0,2.24-7.85L593,1241.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M381.4,1024s-8.58,60.83,16.21,73.26,79.17,20.58,97.9,52.13,52.37,93.47,83,111.26c0,0,17.48-5.68,22.59-14.28,0,0-36.33-95.52-51.49-118.74-13.13-20.1-32.32-49.07-59.59-61.6-7.81-3.58-8.42-11.87-7.05-20.35l2.5-15.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M611.17,955c-34.75,9.92-50.31-87.9-50.17-90.28l-53.29,62.31s31.75,55.87,79.7,61.82a56.65,56.65,0,0,0,31.1-4.56A49.92,49.92,0,0,1,611.17,955Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M675.54,923c-15.15-6.23-28,6.2-28,6.2-15,15.36-26.92,23.12-36.37,25.82a49.92,49.92,0,0,0,7.34,29.29c18.73-8.58,29.65-25.93,34.14-34.58a6.5,6.5,0,0,1,8.58-2.91c3.21,1.56,6.52,3.92,6.73,7.14.41,6.35,8,6.72,8,4.38s-5.85-14.88-5.85-14.88,17.41,11.17,24.18,15.44,12.55-2.78,12.55-2.78S690.69,929.22,675.54,923Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M394.79,824.49s46.7-31.87,159.51,25.76c0,0,11.62,14.73,6.18,31.33s-72.42,106.45-75,148.63c0,0-45.78,27-105.22.23C380.23,1030.44,360.3,919.07,394.79,824.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M492.05,783.75l-18.46,36.17A10.28,10.28,0,0,0,474.66,831c5.08,6.37,15.69,14.93,33.8,9.41a15.89,15.89,0,0,0,10.81-11.5l9.56-40.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M360.2,950.79c-3.16-22,54.94-64.6,54.94-64.6l-20.35-61.7s-110.87,79.12-87.55,143.73c3.34,9.26,8.32,16,14.4,20.79C333.38,964.93,349.3,954.93,360.2,950.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M441.25,956.89s-65.72,18.36-79.35-1.65a10.37,10.37,0,0,1-1.7-4.45c-10.9,4.14-26.82,14.14-38.56,38.22,31.21,24.55,91.37-3,107.72-11.22a11.52,11.52,0,0,1,8.66-.72c5.81,1.81,15.89,4.63,21.5,4.32,8.21-.45,17,29.23,31,21.71C490.52,1003.1,484.17,952.4,441.25,956.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M515.71,724.64c.78.68,34.52,60.6,34.52,60.6L515.6,803.78l-40.41-52S502.54,713.24,515.71,724.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505.27,762.3l14.34,27.31a3.92,3.92,0,0,0,.68.92c1.62,1.63,7.63,6.7,12.55-1.51,4.47-7.45,8.63-14.19,13-16.7A3.46,3.46,0,0,1,551,774a193.77,193.77,0,0,1,9.93,28,5.67,5.67,0,0,1-2.51,6c-6,3.49-18.67,10.48-29.71,13.46a3.38,3.38,0,0,1-3.81-1.45c-4.15-6.35-16.84-25.59-21.16-30.21-4.06-4.32-11.92-1.39-15.18.1a3.41,3.41,0,0,1-3.14,0c-3.33-1.84-10-7.21-3.57-18.68,1.34-2.4.84-5.34-1.11-6.52-3.87-2.36-8.39-7.36-4.05-17.08s12-11.24,16.89-11c1.95.11,3.83-1.47,4.53-3.73a4.07,4.07,0,0,1,3-2.89c2.36-.6,4-3.47,3.53-6.09-.86-5-.24-12,7.1-17.44,13-9.7,24,2.29,26.55,13.21s-12,20.56-21,23c-6.89,1.82-10.76,11.21-12.23,15.6A5.19,5.19,0,0,0,505.27,762.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M498.51,795.85s-7.61-19.55-16.26-18.46-15.12,10-4,19.29C492.18,808.21,498.51,795.85,498.51,795.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525.17,998.74h.35l153.54-.16a6.88,6.88,0,0,0,0-13.75L525.51,985a6.87,6.87,0,0,0-.34,13.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M817.09,859.33H689.22a24.36,24.36,0,0,0-22,14L608.06,998.65H767a14.82,14.82,0,0,0,13.78-9.36l45.84-116A10.22,10.22,0,0,0,817.09,859.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M796.36,1328.05a6.78,6.78,0,0,0,2.55-.51,6.18,6.18,0,0,0,3.37-8.21L667,1014.79a6.54,6.54,0,0,0-8.48-3.27,6.18,6.18,0,0,0-3.38,8.21l135.32,304.54A6.47,6.47,0,0,0,796.36,1328.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M643.92,1328.05a6.47,6.47,0,0,0,5.93-3.78l135.32-304.54a6.19,6.19,0,0,0-3.38-8.21,6.54,6.54,0,0,0-8.48,3.27L638,1319.33a6.19,6.19,0,0,0,3.38,8.21A6.74,6.74,0,0,0,643.92,1328.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M377.5,1328.05a6.7,6.7,0,0,0,2.54-.51,6.17,6.17,0,0,0,3.38-8.21L248.1,1014.79a6.53,6.53,0,0,0-8.47-3.27,6.17,6.17,0,0,0-3.38,8.21l135.32,304.54A6.46,6.46,0,0,0,377.5,1328.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M225.06,1328.05a6.47,6.47,0,0,0,5.93-3.78L366.3,1019.73a6.17,6.17,0,0,0-3.37-8.21,6.54,6.54,0,0,0-8.48,3.27L219.13,1319.33a6.18,6.18,0,0,0,3.38,8.21A6.74,6.74,0,0,0,225.06,1328.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.18,1005.39a7.45,7.45,0,0,1,1.29-5.64,5.82,5.82,0,0,1,4.69-2.47H830.75a6.88,6.88,0,0,1,5.91,3.61,8.67,8.67,0,0,1,.45,7.52l-6.67,16.16a9.32,9.32,0,0,1-8.48,6.08H219.39c-3.39,0-6.3-2.69-6.95-6.42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 761.41,
    cy: 198.23,
    r: 102.91,
    transform: "translate(82.84 596.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 761.41,
    cy: 198.23,
    r: 99.48,
    transform: "translate(82.84 596.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M669.71,195.54h-.12a2.17,2.17,0,0,1-2.06-2.28,95.1,95.1,0,0,1,1.37-11.81,2.17,2.17,0,1,1,4.28.77,88.36,88.36,0,0,0-1.3,11.27A2.17,2.17,0,0,1,669.71,195.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M679.38,159.08a2.14,2.14,0,0,1-1-.23,2.18,2.18,0,0,1-1-2.92,93.62,93.62,0,0,1,84-51.71,95.1,95.1,0,0,1,17,1.53,2.18,2.18,0,0,1-.78,4.28,89.78,89.78,0,0,0-96.27,47.86A2.16,2.16,0,0,1,679.38,159.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 763.58,
    cy: 200.4,
    r: 84.2,
    transform: "translate(81.94 598.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M789.36,168.58c0,14.26-11.56,29.65-25.81,29.65s-25.82-15.39-25.82-29.65,11.56-24.37,25.82-24.37S789.36,154.33,789.36,168.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M731.51,253.13h63a15.27,15.27,0,0,0,14.53-10.61l3.39-10.6a15.25,15.25,0,0,0-9.21-19c-25.65-9.38-52.16-8.17-79.33.87a15.18,15.18,0,0,0-9.73,18.41l2.61,9.63A15.25,15.25,0,0,0,731.51,253.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-60",
    cx: 563.11,
    cy: 288.63,
    r: 65.65,
    transform: "translate(-51.25 137.1) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-61",
    cx: 563.11,
    cy: 288.63,
    r: 63.47,
    transform: "translate(-39.16 482.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M504.61,287.7h-.12a2.17,2.17,0,0,1-2.06-2.28,60.62,60.62,0,0,1,.89-7.63,2.17,2.17,0,1,1,4.27.77,59.7,59.7,0,0,0-.82,7.08A2.17,2.17,0,0,1,504.61,287.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M510.77,264.44a2.1,2.1,0,0,1-1-.23,2.17,2.17,0,0,1-1-2.92,60.51,60.51,0,0,1,54.28-33.42,61.62,61.62,0,0,1,11,1,2.18,2.18,0,0,1-.78,4.28,57.61,57.61,0,0,0-10.18-.91,56.19,56.19,0,0,0-50.39,31A2.19,2.19,0,0,1,510.77,264.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 564.49,
    cy: 290.01,
    r: 53.72,
    transform: "translate(152.54 772.77) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M580.94,269.72c0,9.09-7.37,18.91-16.47,18.91S548,278.81,548,269.72s7.37-15.55,16.47-15.55S580.94,260.62,580.94,269.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M544,323.65h40.21a9.74,9.74,0,0,0,9.27-6.77l2.16-6.76A9.72,9.72,0,0,0,589.8,298c-16.37-6-33.28-5.22-50.62.55A9.69,9.69,0,0,0,533,310.33l1.67,6.14A9.73,9.73,0,0,0,544,323.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 590.8,
    cy: 494.01,
    r: 65.65,
    transform: "translate(-91.69 850.79) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 590.8,
    cy: 494.01,
    r: 63.47,
    transform: "translate(-176.27 562.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M532.3,493.07h-.12a2.18,2.18,0,0,1-2.06-2.29,60.84,60.84,0,0,1,.89-7.63,2.17,2.17,0,1,1,4.27.78,59.46,59.46,0,0,0-.82,7.08A2.17,2.17,0,0,1,532.3,493.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M538.46,469.82a2.11,2.11,0,0,1-1-.24,2.17,2.17,0,0,1-1-2.92,60.84,60.84,0,0,1,65.24-32.43,2.18,2.18,0,0,1-.78,4.28,56.77,56.77,0,0,0-10.18-.92,56.18,56.18,0,0,0-50.39,31A2.19,2.19,0,0,1,538.46,469.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 592.18,
    cy: 495.39,
    r: 53.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M608.63,475.09c0,9.1-7.37,18.92-16.47,18.92s-16.47-9.82-16.47-18.92,7.37-15.55,16.47-15.55S608.63,466,608.63,475.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M571.72,529h40.21a9.72,9.72,0,0,0,9.26-6.77l2.17-6.76a9.73,9.73,0,0,0-5.87-12.1c-16.37-6-33.29-5.21-50.62.55a9.7,9.7,0,0,0-6.21,11.75l1.67,6.14A9.74,9.74,0,0,0,571.72,529Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-68",
    cx: 978.62,
    cy: 189.58,
    r: 41.62,
    transform: "translate(1.94 388.93) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-69",
    cx: 978.62,
    cy: 189.58,
    r: 40.23,
    transform: "translate(152.57 747.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M941.53,189.79h-.12a2.17,2.17,0,0,1-2-2.29,38.7,38.7,0,0,1,.57-4.94,2.17,2.17,0,0,1,4.28.77,35.69,35.69,0,0,0-.51,4.4A2.17,2.17,0,0,1,941.53,189.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M945.44,175.05a2.15,2.15,0,0,1-1-.24,2.18,2.18,0,0,1-1-2.92,39.37,39.37,0,0,1,42.21-21,2.18,2.18,0,0,1,1.75,2.53,2.15,2.15,0,0,1-2.53,1.74,35.85,35.85,0,0,0-6.31-.56,34.83,34.83,0,0,0-31.24,19.23A2.17,2.17,0,0,1,945.44,175.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 979.49,
    cy: 190.46,
    r: 34.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M989.92,177.59c0,5.77-4.67,12-10.44,12s-10.44-6.22-10.44-12,4.67-9.85,10.44-9.85S989.92,171.83,989.92,177.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M966.52,211.78H992a6.18,6.18,0,0,0,5.88-4.28l1.37-4.29a6.17,6.17,0,0,0-3.73-7.67c-10.37-3.79-21.09-3.31-32.08.35a6.14,6.14,0,0,0-3.94,7.45l1.06,3.89A6.16,6.16,0,0,0,966.52,211.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M977.37,365.75a2.18,2.18,0,0,1-1.61-.71c-.83-.92-1.68-1.84-2.54-2.75a2.17,2.17,0,0,1,3.15-3c.89.94,1.76,1.87,2.61,2.81a2.18,2.18,0,0,1-1.61,3.64Zm-13.46-13.44a2.16,2.16,0,0,1-1.46-.56q-2.38-2.17-4.84-4.31a2.17,2.17,0,0,1,2.85-3.28q2.5,2.16,4.92,4.37a2.17,2.17,0,0,1-1.47,3.78Zm-16.63-14a2.18,2.18,0,0,1-1.34-.46c-1.7-1.34-3.42-2.66-5.14-3.95a2.18,2.18,0,0,1,2.62-3.48c1.74,1.32,3.48,2.65,5.2,4a2.18,2.18,0,0,1-1.34,3.89Zm-17.5-12.9a2.19,2.19,0,0,1-1.24-.39c-1.8-1.25-3.58-2.47-5.36-3.67a2.18,2.18,0,0,1,2.43-3.61c1.79,1.21,3.6,2.45,5.41,3.71a2.17,2.17,0,0,1-1.24,4Zm-18.16-12a2.14,2.14,0,0,1-1.16-.34c-1.87-1.17-3.71-2.32-5.52-3.43a2.17,2.17,0,1,1,2.27-3.7c1.82,1.11,3.68,2.27,5.57,3.45a2.18,2.18,0,0,1-1.16,4ZM893,302.17a2.17,2.17,0,0,1-1.09-.29q-3-1.69-5.66-3.21a2.17,2.17,0,1,1,2.12-3.79c1.81,1,3.72,2.09,5.71,3.23a2.17,2.17,0,0,1-1.08,4.06Zm-19.11-10.46a2.23,2.23,0,0,1-1-.24c-3.68-1.91-5.79-2.93-5.8-2.94a2.17,2.17,0,1,1,1.89-3.91s2.15,1,5.91,3a2.17,2.17,0,0,1-1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M662.81,479a2.18,2.18,0,0,1-1-4.11c.08,0,2.13-1.09,6-2.84a2.17,2.17,0,0,1,1.79,4c-3.78,1.7-5.8,2.74-5.82,2.75A2.23,2.23,0,0,1,662.81,479Zm20-8.69a2.18,2.18,0,0,1-.8-4.2c1.92-.75,4-1.54,6.13-2.35a2.17,2.17,0,1,1,1.52,4.07c-2.14.81-4.16,1.58-6.06,2.33A2.21,2.21,0,0,1,682.79,470.26Zm20.46-7.39a2.18,2.18,0,0,1-.68-4.24q3-1,6.23-2a2.18,2.18,0,0,1,1.32,4.15q-3.2,1-6.18,2A2.37,2.37,0,0,1,703.25,462.87Zm20.81-6.35a2.18,2.18,0,0,1-.59-4.27q3.1-.87,6.33-1.72a2.17,2.17,0,1,1,1.11,4.2q-3.2.86-6.27,1.71A2.32,2.32,0,0,1,724.06,456.52Zm21.07-5.38a2.17,2.17,0,0,1-.48-4.29c2.1-.49,4.23-1,6.39-1.43a2.17,2.17,0,1,1,.92,4.25c-2.14.46-4.25.94-6.34,1.42A2,2,0,0,1,745.13,451.14Zm21.3-4.42a2.17,2.17,0,0,1-.39-4.31c2.12-.39,4.28-.78,6.45-1.14a2.18,2.18,0,0,1,.73,4.29q-3.24.54-6.39,1.13Zm155.72-2.87-.33,0-4.18-.61a2.18,2.18,0,0,1,.61-4.31l4.22.62a2.18,2.18,0,0,1-.32,4.33Zm-134.25-.59a2.18,2.18,0,0,1-.29-4.33c2.14-.29,4.31-.58,6.5-.85a2.17,2.17,0,0,1,.54,4.31c-2.17.27-4.32.56-6.45.85A1.51,1.51,0,0,1,787.9,443.26Zm115-1.9h-.24q-3.24-.35-6.45-.65a2.17,2.17,0,1,1,.4-4.33c2.16.2,4.34.42,6.52.65a2.18,2.18,0,0,1-.23,4.34Zm-93.34-.59a2.17,2.17,0,0,1-.2-4.34c2.16-.2,4.33-.39,6.53-.57a2.18,2.18,0,1,1,.34,4.34q-3.25.26-6.47.56Zm71.68-1.22h-.13q-3.27-.19-6.49-.34a2.18,2.18,0,0,1,.2-4.35q3.26.15,6.54.35a2.17,2.17,0,0,1-.12,4.34Zm-50-.3a2.18,2.18,0,0,1-.1-4.35q3.25-.15,6.55-.26a2.17,2.17,0,1,1,.15,4.34c-2.18.08-4.35.16-6.49.27Zm28.26-.49h0l-6,0h-.48a2.18,2.18,0,0,1,0-4.35h.48l6.07,0a2.18,2.18,0,0,1,0,4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M900.46,399a2.22,2.22,0,0,1-.8-.15c-1.93-.76-4-1.53-6.07-2.3a2.17,2.17,0,1,1,1.5-4.08c2.14.78,4.2,1.56,6.16,2.33a2.18,2.18,0,0,1-.79,4.2Zm-20.54-7.32a2.06,2.06,0,0,1-.68-.11q-3-1-6.19-2a2.18,2.18,0,1,1,1.31-4.15q3.2,1,6.25,2a2.18,2.18,0,0,1-.69,4.24Zm-20.8-6.49a2.16,2.16,0,0,1-.62-.09q-3.09-.93-6.26-1.84a2.18,2.18,0,0,1,1.22-4.18c2.12.62,4.22,1.23,6.28,1.85a2.18,2.18,0,0,1-.62,4.26Zm-21-6a2.32,2.32,0,0,1-.58-.08q-3.12-.87-6.29-1.73a2.18,2.18,0,0,1,1.15-4.2l6.31,1.74a2.18,2.18,0,0,1-.59,4.27Zm-21-5.68a2.09,2.09,0,0,1-.55-.08l-6.32-1.65a2.18,2.18,0,1,1,1.1-4.21l6.32,1.66a2.18,2.18,0,0,1-.55,4.28ZM796,368a2.46,2.46,0,0,1-.53-.06l-6.33-1.59a2.17,2.17,0,0,1,1.05-4.22l6.34,1.59A2.17,2.17,0,0,1,796,368Zm-21.14-5.24a2.31,2.31,0,0,1-.52-.06l-6.33-1.54a2.18,2.18,0,0,1,1-4.23l6.34,1.54a2.18,2.18,0,0,1-.51,4.29Zm-21.18-5.08a2.2,2.2,0,0,1-.5-.06l-6.35-1.5a2.17,2.17,0,1,1,1-4.23l6.36,1.5a2.17,2.17,0,0,1-.5,4.29Zm-21.22-4.95a2.12,2.12,0,0,1-.49-.06l-6.36-1.46a2.17,2.17,0,1,1,1-4.24l6.37,1.47a2.17,2.17,0,0,1-.49,4.29Zm-21.24-4.83a2.81,2.81,0,0,1-.49-.05l-6.37-1.43a2.18,2.18,0,0,1,1-4.25l6.38,1.43a2.18,2.18,0,0,1-.47,4.3ZM690,343.18a1.83,1.83,0,0,1-.47-.05l-6.39-1.39a2.19,2.19,0,0,1-1.66-2.59,2.16,2.16,0,0,1,2.59-1.66l6.39,1.4a2.17,2.17,0,0,1-.46,4.29Zm-21.31-4.62a1.75,1.75,0,0,1-.46-.05l-6.4-1.36a2.18,2.18,0,0,1,.91-4.26l6.4,1.37a2.17,2.17,0,0,1-.45,4.3Zm-21.36-4.51a2.3,2.3,0,0,1-.45-.05c-4.17-.87-6.45-1.33-6.46-1.33a2.17,2.17,0,0,1,.87-4.26l6.48,1.33a2.18,2.18,0,0,1-.44,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1020.23,283.82a2.17,2.17,0,0,1-2.12-1.72c-.18-.88-.41-1.76-.68-2.65a2.18,2.18,0,1,1,4.17-1.25c.3,1,.56,2,.76,3a2.17,2.17,0,0,1-1.68,2.58A2.28,2.28,0,0,1,1020.23,283.82Zm-7.15-16.59a2.19,2.19,0,0,1-1.87-1c-1.06-1.75-2.23-3.55-3.48-5.37a2.17,2.17,0,0,1,3.57-2.47c1.31,1.88,2.53,3.76,3.63,5.58a2.17,2.17,0,0,1-1.85,3.3Zm-12.9-17.51a2.18,2.18,0,0,1-1.66-.76c-2.52-2.94-4.27-4.75-4.29-4.77a2.17,2.17,0,0,1,3.13-3c.07.07,1.85,1.91,4.46,5a2.17,2.17,0,0,1-1.64,3.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 1519.53,
    cy: 198.23,
    r: 102.91,
    transform: "translate(304.89 1132.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-74",
    cx: 1519.53,
    cy: 198.23,
    r: 99.48,
    transform: "translate(304.89 1132.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1611.24,195.54a2.17,2.17,0,0,1-2.17-2.06,90.2,90.2,0,0,0-1.3-11.27,2.17,2.17,0,1,1,4.28-.77,93.22,93.22,0,0,1,1.36,11.81,2.16,2.16,0,0,1-2.05,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1601.57,159.08a2.15,2.15,0,0,1-1.94-1.19A89.78,89.78,0,0,0,1503.36,110a2.18,2.18,0,0,1-.78-4.28,95.07,95.07,0,0,1,17-1.53,93.63,93.63,0,0,1,84,51.71,2.17,2.17,0,0,1-1.94,3.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 1517.37,
    cy: 200.4,
    r: 84.2,
    transform: "translate(-10.52 290.56) rotate(-10.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1491.59,168.58c0,14.26,11.56,29.65,25.81,29.65s25.82-15.39,25.82-29.65-11.56-24.37-25.82-24.37S1491.59,154.33,1491.59,168.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1549.44,253.13h-63a15.26,15.26,0,0,1-14.53-10.61l-3.39-10.6a15.24,15.24,0,0,1,9.21-19c25.64-9.38,52.16-8.17,79.33.87a15.18,15.18,0,0,1,9.73,18.41l-2.61,9.63A15.25,15.25,0,0,1,1549.44,253.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-77",
    cx: 1717.84,
    cy: 288.63,
    r: 65.65,
    transform: "translate(1031.32 1889.56) rotate(-76.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-78",
    cx: 1717.84,
    cy: 288.63,
    r: 63.47,
    transform: "translate(299.05 1299.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1776.34,287.7a2.17,2.17,0,0,1-2.17-2.07,55.8,55.8,0,0,0-.82-7.08,2.17,2.17,0,1,1,4.28-.77,60.61,60.61,0,0,1,.88,7.63,2.16,2.16,0,0,1-2,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1770.17,264.44a2.17,2.17,0,0,1-1.94-1.2,56.19,56.19,0,0,0-50.39-31,57.52,57.52,0,0,0-10.18.91,2.18,2.18,0,0,1-.78-4.28,61.53,61.53,0,0,1,11-1,60.49,60.49,0,0,1,54.27,33.42,2.18,2.18,0,0,1-1,2.92A2.14,2.14,0,0,1,1770.17,264.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 1716.45,
    cy: 290.01,
    r: 53.72,
    transform: "translate(-20.51 405.29) rotate(-13.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1700,269.72c0,9.09,7.37,18.91,16.47,18.91s16.47-9.82,16.47-18.91-7.38-15.55-16.47-15.55S1700,260.62,1700,269.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1736.92,323.65h-40.21a9.74,9.74,0,0,1-9.27-6.77l-2.16-6.76a9.72,9.72,0,0,1,5.87-12.09c16.36-6,33.28-5.22,50.61.55a9.69,9.69,0,0,1,6.21,11.75l-1.66,6.14A9.73,9.73,0,0,1,1736.92,323.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-81",
    cx: 1690.15,
    cy: 494.01,
    r: 65.65,
    transform: "translate(145.72 1339.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-82",
    cx: 1690.15,
    cy: 494.01,
    r: 63.47,
    transform: "translate(145.72 1339.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1748.65,493.07a2.17,2.17,0,0,1-2.17-2.06,55.59,55.59,0,0,0-.82-7.08,2.18,2.18,0,0,1,4.28-.78,60.82,60.82,0,0,1,.88,7.63,2.17,2.17,0,0,1-2,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1742.48,469.82a2.17,2.17,0,0,1-1.94-1.2,56.18,56.18,0,0,0-50.39-31,56.77,56.77,0,0,0-10.18.92,2.18,2.18,0,0,1-.78-4.28,60.82,60.82,0,0,1,65.23,32.43,2.18,2.18,0,0,1-1,2.92A2.15,2.15,0,0,1,1742.48,469.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 1688.76,
    cy: 495.39,
    r: 53.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1672.32,475.09c0,9.1,7.37,18.92,16.47,18.92s16.47-9.82,16.47-18.92-7.38-15.55-16.47-15.55S1672.32,466,1672.32,475.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1709.23,529H1669a9.74,9.74,0,0,1-9.27-6.77l-2.16-6.76a9.72,9.72,0,0,1,5.87-12.1c16.36-6,33.28-5.21,50.61.55a9.69,9.69,0,0,1,6.21,11.75l-1.66,6.14A9.74,9.74,0,0,1,1709.23,529Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-85",
    cx: 1302.33,
    cy: 189.58,
    r: 41.62,
    transform: "translate(628.8 1320.23) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-86",
    cx: 1302.33,
    cy: 189.58,
    r: 40.23,
    transform: "matrix(0.81, -0.58, 0.58, 0.81, 134.97, 797.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1339.42,189.79a2.17,2.17,0,0,1-2.17-2.06,35.69,35.69,0,0,0-.51-4.4,2.17,2.17,0,0,1,4.28-.77,40.59,40.59,0,0,1,.57,4.94,2.19,2.19,0,0,1-2.06,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1335.51,175.05a2.16,2.16,0,0,1-1.94-1.2,34.83,34.83,0,0,0-31.24-19.23,35.77,35.77,0,0,0-6.31.56,2.17,2.17,0,1,1-.78-4.27,39.37,39.37,0,0,1,42.21,21,2.19,2.19,0,0,1-1.94,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1267.4,190.46a34.06,34.06,0,1,0,34-34.05A34.05,34.05,0,0,0,1267.4,190.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1291,177.59c0,5.77,4.67,12,10.44,12s10.44-6.22,10.44-12-4.68-9.85-10.44-9.85S1291,171.83,1291,177.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1314.42,211.78h-25.48a6.17,6.17,0,0,1-5.88-4.28l-1.37-4.29a6.17,6.17,0,0,1,3.72-7.67c10.38-3.79,21.1-3.31,32.09.35a6.14,6.14,0,0,1,3.93,7.45l-1,3.89A6.17,6.17,0,0,1,1314.42,211.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1303.57,365.75a2.18,2.18,0,0,1-1.6-3.64c.85-.94,1.72-1.87,2.6-2.81a2.18,2.18,0,0,1,3.16,3c-.86.91-1.71,1.83-2.55,2.75A2.15,2.15,0,0,1,1303.57,365.75ZM1317,352.31a2.15,2.15,0,0,1-1.6-.7,2.18,2.18,0,0,1,.14-3.08q2.42-2.2,4.91-4.37a2.17,2.17,0,1,1,2.85,3.28c-1.63,1.42-3.25,2.86-4.83,4.31A2.17,2.17,0,0,1,1317,352.31Zm16.64-14a2.18,2.18,0,0,1-1.35-3.89c1.73-1.35,3.46-2.68,5.21-4a2.18,2.18,0,0,1,2.62,3.48q-2.6,1.94-5.14,3.95A2.18,2.18,0,0,1,1333.67,338.29Zm17.5-12.9a2.18,2.18,0,0,1-1.25-4q2.73-1.89,5.42-3.71a2.18,2.18,0,1,1,2.43,3.61q-2.67,1.8-5.36,3.67A2.19,2.19,0,0,1,1351.17,325.39Zm18.16-12a2.18,2.18,0,0,1-1.16-4c1.89-1.18,3.75-2.34,5.57-3.45a2.17,2.17,0,1,1,2.27,3.7c-1.81,1.11-3.65,2.26-5.53,3.43A2.11,2.11,0,0,1,1369.33,313.39ZM1388,302.17a2.17,2.17,0,0,1-1.08-4.06q3-1.71,5.71-3.23a2.17,2.17,0,1,1,2.11,3.79l-5.66,3.21A2.11,2.11,0,0,1,1388,302.17Zm19.11-10.46a2.17,2.17,0,0,1-1-4.1c3.75-1.95,5.9-3,5.9-3a2.17,2.17,0,1,1,1.9,3.91s-2.12,1-5.8,2.94A2.23,2.23,0,0,1,1407.1,291.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1618.13,479a2.22,2.22,0,0,1-1-.24s-2-1-5.82-2.75a2.17,2.17,0,1,1,1.79-4c3.89,1.75,5.93,2.79,6,2.84a2.18,2.18,0,0,1-1,4.11Zm-20-8.69a2.21,2.21,0,0,1-.79-.15c-1.9-.75-3.92-1.52-6.07-2.33a2.17,2.17,0,0,1,1.53-4.07c2.17.81,4.21,1.6,6.13,2.35a2.18,2.18,0,0,1-.8,4.2Zm-20.46-7.39a2.37,2.37,0,0,1-.69-.11q-3-1-6.18-2a2.18,2.18,0,0,1,1.31-4.15q3.22,1,6.24,2a2.18,2.18,0,0,1-.68,4.24Zm-20.81-6.35a2.46,2.46,0,0,1-.59-.08q-3.06-.85-6.26-1.71a2.17,2.17,0,1,1,1.11-4.2q3.22.86,6.32,1.72a2.18,2.18,0,0,1-.58,4.27Zm-21.08-5.38a2.09,2.09,0,0,1-.49-.05c-2.08-.48-4.19-1-6.34-1.42a2.18,2.18,0,0,1,.93-4.25c2.16.47,4.29.94,6.39,1.43a2.17,2.17,0,0,1-.49,4.29Zm-21.29-4.42a2.69,2.69,0,0,1-.4,0q-3.16-.58-6.39-1.13a2.18,2.18,0,0,1,.72-4.29c2.18.36,4.33.75,6.46,1.14a2.17,2.17,0,0,1-.39,4.31Zm-155.72-2.87a2.18,2.18,0,0,1-.32-4.33l4.22-.62a2.18,2.18,0,0,1,.61,4.31l-4.18.61Zm134.25-.59a1.51,1.51,0,0,1-.3,0c-2.13-.29-4.28-.58-6.45-.85a2.17,2.17,0,0,1,.54-4.31c2.19.27,4.36.56,6.5.85a2.18,2.18,0,0,1-.29,4.33Zm-115-1.9a2.18,2.18,0,0,1-.23-4.34c2.18-.23,4.36-.45,6.52-.65a2.17,2.17,0,1,1,.4,4.33q-3.21.3-6.45.65Zm93.34-.6h-.2q-3.21-.3-6.48-.56a2.18,2.18,0,0,1,.35-4.34c2.19.18,4.37.36,6.53.56a2.17,2.17,0,0,1-.2,4.34Zm-71.68-1.21a2.17,2.17,0,0,1-.12-4.34q3.28-.19,6.54-.35a2.15,2.15,0,0,1,2.27,2.08,2.18,2.18,0,0,1-2.08,2.27q-3.22.15-6.48.34Zm50-.3h-.11q-3.23-.15-6.49-.26a2.18,2.18,0,1,1,.15-4.35c2.19.07,4.38.16,6.55.26a2.18,2.18,0,0,1-.1,4.35Zm-28.26-.49a2.18,2.18,0,0,1,0-4.35l6.07,0h.48a2.18,2.18,0,0,1,0,4.35h-.48l-6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1380.49,399a2.18,2.18,0,0,1-.79-4.2q2.94-1.15,6.15-2.33a2.18,2.18,0,1,1,1.51,4.08c-2.11.77-4.14,1.54-6.07,2.3A2.22,2.22,0,0,1,1380.49,399Zm20.53-7.32a2.18,2.18,0,0,1-.68-4.24l6.24-2a2.18,2.18,0,1,1,1.32,4.15c-2.11.67-4.18,1.34-6.19,2A2.07,2.07,0,0,1,1401,391.63Zm20.81-6.49a2.18,2.18,0,0,1-.62-4.26c2.06-.62,4.16-1.23,6.28-1.85a2.18,2.18,0,1,1,1.22,4.18c-2.12.61-4.2,1.22-6.26,1.84A2.27,2.27,0,0,1,1421.83,385.14Zm20.94-6a2.18,2.18,0,0,1-.58-4.27l6.31-1.74a2.18,2.18,0,0,1,1.15,4.2c-2.12.57-4.21,1.15-6.29,1.73A2.39,2.39,0,0,1,1442.77,379.13Zm21-5.68a2.18,2.18,0,0,1-.55-4.28l6.32-1.66a2.18,2.18,0,0,1,1.1,4.21l-6.32,1.65A2.09,2.09,0,0,1,1463.81,373.45ZM1484.9,368a2.17,2.17,0,0,1-.52-4.28l6.33-1.59a2.18,2.18,0,1,1,1.06,4.22l-6.33,1.59A2.48,2.48,0,0,1,1484.9,368Zm21.15-5.24a2.18,2.18,0,0,1-.51-4.29l6.34-1.54a2.18,2.18,0,0,1,1,4.23l-6.33,1.54A2.37,2.37,0,0,1,1506.05,362.77Zm21.17-5.08a2.17,2.17,0,0,1-.5-4.29l6.37-1.5a2.17,2.17,0,0,1,1,4.23l-6.35,1.5A2.22,2.22,0,0,1,1527.22,357.69Zm21.22-4.95a2.17,2.17,0,0,1-.48-4.29l6.37-1.47a2.17,2.17,0,0,1,1,4.24l-6.36,1.46A2.14,2.14,0,0,1,1548.44,352.74Zm21.25-4.83a2.18,2.18,0,0,1-.47-4.3l6.38-1.43a2.18,2.18,0,0,1,.94,4.25l-6.37,1.43A2.61,2.61,0,0,1,1569.69,347.91Zm21.28-4.73a2.17,2.17,0,0,1-.46-4.29l6.39-1.4a2.17,2.17,0,1,1,.92,4.25l-6.38,1.39A1.88,1.88,0,0,1,1591,343.18Zm21.31-4.62a2.17,2.17,0,0,1-.45-4.3l6.4-1.37a2.18,2.18,0,0,1,.91,4.26l-6.4,1.36A1.8,1.8,0,0,1,1612.28,338.56Zm21.36-4.51a2.18,2.18,0,0,1-.44-4.31l6.48-1.33a2.17,2.17,0,0,1,.87,4.26s-2.3.46-6.46,1.33A2.3,2.3,0,0,1,1633.64,334.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1223.82,315.64a2.11,2.11,0,0,1-1.28-.42,2.16,2.16,0,0,1-.48-3c1.23-1.7,2.55-3.47,4-5.29a2.18,2.18,0,0,1,3.45,2.66c-1.37,1.78-2.67,3.52-3.88,5.18A2.17,2.17,0,0,1,1223.82,315.64Zm13.44-17.14a2.18,2.18,0,0,1-1.68-3.56c1.38-1.66,2.78-3.35,4.2-5a2.18,2.18,0,0,1,3.33,2.8c-1.41,1.68-2.81,3.35-4.18,5A2.17,2.17,0,0,1,1237.26,298.5Zm14.13-16.58a2.17,2.17,0,0,1-1.64-3.6c1.45-1.66,2.9-3.3,4.33-4.92a2.18,2.18,0,1,1,3.26,2.89l-4.32,4.89A2.15,2.15,0,0,1,1251.39,281.92Zm14.5-16.25a2.18,2.18,0,0,1-1.61-3.64l4.41-4.84a2.18,2.18,0,0,1,3.21,2.94c-1.41,1.53-2.88,3.15-4.4,4.82A2.15,2.15,0,0,1,1265.89,265.67Zm14.76-16a2.18,2.18,0,0,1-1.58-3.66c2.83-3,4.51-4.8,4.51-4.8a2.18,2.18,0,1,1,3.15,3s-1.67,1.75-4.49,4.77A2.21,2.21,0,0,1,1280.65,249.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-89",
    cx: 1148.99,
    cy: 156.4,
    r: 65.65,
    transform: "translate(9.5 371.37) rotate(-18.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-90",
    cx: 1148.99,
    cy: 156.4,
    r: 63.47,
    transform: "translate(225.94 858.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1207.5,155.47a2.17,2.17,0,0,1-2.17-2.07,57.68,57.68,0,0,0-.82-7.08,2.17,2.17,0,1,1,4.28-.77,60.61,60.61,0,0,1,.88,7.63,2.17,2.17,0,0,1-2.06,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1201.33,132.21a2.18,2.18,0,0,1-1.94-1.19,56.18,56.18,0,0,0-50.4-31,57.78,57.78,0,0,0-10.18.91,2.17,2.17,0,1,1-.78-4.27,60.84,60.84,0,0,1,65.24,32.43,2.17,2.17,0,0,1-1.94,3.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 1147.61,
    cy: 157.78,
    r: 53.72,
    transform: "translate(224.56 857.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1131.16,137.49c0,9.09,7.38,18.91,16.47,18.91s16.47-9.82,16.47-18.91-7.37-15.55-16.47-15.55S1131.16,128.39,1131.16,137.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1168.07,191.42h-40.2a9.73,9.73,0,0,1-9.27-6.77l-2.16-6.76a9.71,9.71,0,0,1,5.87-12.09c16.36-6,33.28-5.22,50.61.55a9.69,9.69,0,0,1,6.21,11.75l-1.67,6.14A9.72,9.72,0,0,1,1168.07,191.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1148,259.78a2.18,2.18,0,0,1-2.18-2.18v-6.52a2.18,2.18,0,0,1,4.35,0v6.52A2.17,2.17,0,0,1,1148,259.78Zm0-21.75a2.18,2.18,0,0,1-2.18-2.17v-6.52a2.18,2.18,0,1,1,4.35,0v6.52A2.17,2.17,0,0,1,1148,238Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingImg4);
export default __webpack_public_path__ + "static/media/banking_img_4.924a5a4ad25abcd7d1a0835a8472592d.svg";
export { ForwardRef as ReactComponent };